<template>
  <svg
    id="milestone-seed"
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="350"
    height="375"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 304.6 325.4"
    aria-labelledby="netlifyseedfundinground"
    role="presentation"
  >
    <title id="netlifyseedfundinground">Netlify's Seed Funding Round</title>
    <g>
      <path
        class="cls-2"
        d="M95.3,97.2V58.4s0-.2-.1-.2L82.8,59.3l-1.2-6.9h-.1L70.1,59H70l-2.3-.6c-.1,0-.1,0-.1.1V97.2c0,.4.3.6.5.9l11.5,6.7a3.1,3.1,0,0,0,3.2,0l11.6-6.7C95.1,98,95.3,97.6,95.3,97.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M81.5,106a3.5,3.5,0,0,1-2-.5L68,98.8a1.7,1.7,0,0,1-.9-1.5V58.1l.2-.3a.8.8,0,0,1,.7-.1l2,.5,11.2-6.4a.6.6,0,0,1,.8,0h.3l1,6.6,11.9-1h.1c.4.1.5.3.5.7v39a1.9,1.9,0,0,1-.9,1.6l-11.6,6.7A3.7,3.7,0,0,1,81.5,106ZM68.4,59.3v38a.5.5,0,0,0,.3.4l11.4,6.7a2.8,2.8,0,0,0,2.5,0l11.7-6.7c.2-.1.2-.4.2-.4V59.2l-11.9,1h-.5l-1-6.4-11,6.2h-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M95.2,58.2,82.8,59.3l-1.5,4.2v41.7a3.3,3.3,0,0,0,1.7-.4l11.7-6.7a1.7,1.7,0,0,0,.6-1.1c0,.2,0-38.2-.1-38.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M81.5,106h-.8V63.4l1.7-5,.5.2,12.3-1h.1c.4.1.5.4.5.8V97.3a1.8,1.8,0,0,1-.9,1.6l-11.6,6.7A5.3,5.3,0,0,1,81.5,106ZM82,63.7v40.9c.3,0,.4-.2.6-.3l11.7-6.7a.6.6,0,0,0,.2-.4V59L83.2,60.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M69.5,60l.3-1.1-1.9-.5c-.2,0-.2,0-.2.1V97.2c0,.4.3.6.6.9l1.2.7V60Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M70.2,99.9l-2.1-1.3a1.6,1.6,0,0,1-.9-1.4V58l.3-.3a.6.6,0,0,1,.6-.1l2.8.8-.3.6a2.3,2.3,0,0,1-.4,1ZM68.4,59.3v38a.5.5,0,0,0,.3.4h.1V60.1h0a1,1,0,0,1,.1-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M79.9,66,68.4,59.3a1.2,1.2,0,0,1,0-2.1l11.7-6.7a2.9,2.9,0,0,1,3.1,0l11.5,6.7a1.2,1.2,0,0,1,0,2.1L82.9,66A2.4,2.4,0,0,1,79.9,66Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M81.5,67.2a3,3,0,0,1-1.9-.5L68.1,60a2.2,2.2,0,0,1-.9-1.6,1.9,1.9,0,0,1,.9-1.6l11.8-6.7a3.5,3.5,0,0,1,3.7,0l11.5,6.7a1.9,1.9,0,0,1,0,3.2L83.3,66.7A3.7,3.7,0,0,1,81.5,67.2Zm.1-16.3-1.2.2L68.7,57.8a.6.6,0,0,0-.3.6.5.5,0,0,0,.3.5l11.4,6.7a2.5,2.5,0,0,0,2.4,0l11.8-6.7c.2-.1.2-.4.2-.5a.7.7,0,0,0-.2-.6L82.8,51.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M89.8,50.1H73a.4.4,0,0,0-.4.4v4.4q0,.9,1.2,1.5l5,2.9a5.1,5.1,0,0,0,4.8.1l5.6-3.3a1.5,1.5,0,0,0,.8-1.3V50.5C90,50.2,89.9,50.1,89.8,50.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M81.5,60.5a5.5,5.5,0,0,1-2.9-.8l-5.1-2.9a3.2,3.2,0,0,1-1.4-1.9V50.5a.9.9,0,0,1,.9-1H89.8c.2,0,.4.2.6.3a.8.8,0,0,1,.3.7v5a1.8,1.8,0,0,1-1.1,1.2L84,60A10.1,10.1,0,0,1,81.5,60.5Zm-8.4-9.9v4.3c0,.3.4.7,1,1.1l5,2.9a4.5,4.5,0,0,0,4.2.1L89,55.7a1,1,0,0,0,.5-.8V50.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M89.8,50.1H82.1V60a4.7,4.7,0,0,0,1.6-.4l5.7-3.3a1.7,1.7,0,0,0,.8-1.4V50.5C90,50.2,89.9,50.1,89.8,50.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M89.2,51.4l-5.6,3.3a5.8,5.8,0,0,1-4.8-.2l-5-2.9c-1.4-.7-1.6-1.9-.4-2.7l5.7-3.3a5.2,5.2,0,0,1,4.7.1l5.1,2.9C90.3,49.4,90.4,50.6,89.2,51.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M81.5,55.6a5.5,5.5,0,0,1-2.9-.8l-5.1-2.9a2.3,2.3,0,0,1-1.4-2,2,2,0,0,1,1-1.6L78.8,45a6.6,6.6,0,0,1,5.3.2l5,2.9a2.5,2.5,0,0,1,1.5,2,1.8,1.8,0,0,1-1.1,1.5l-5.7,3.5A4.1,4.1,0,0,1,81.5,55.6Zm-.3-10a3.4,3.4,0,0,0-1.8.4l-5.7,3.3a.9.9,0,0,0-.6.8c0,.4.4.8,1,1l5,2.9a4.8,4.8,0,0,0,4.2.2L89,50.9c.2-.2.5-.4.5-.8s-.4-.8-.9-1.1l-5-2.9A4.9,4.9,0,0,0,81.2,45.6Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M88.5,53.4h-.8v1.9h.8Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M80,56.1h-.8v3.5H80Z" transform="translate(-1 -0.4)" />
    </g>
    <path class="cls-3" d="M283.6,210.5l-.5-.2L144.4,290l.7.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M286.1,212.1l-.5-.3L147.2,291.5l.5.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M288.7,213.6l-.5-.5L149.5,293l.7.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M291.2,214.9l-.5-.3L152,294.6l.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M293.8,216.4l-.5-.3L154.6,295.8l.7.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M296.4,217.9l-.6-.2L157.1,297.4l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M298.9,219.5l-.5-.5L159.7,298.9l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M301.5,221l-.5-.5L162.5,300.4l.5.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M303.8,222.5l-.6-.5L164.8,301.7l.8.3Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M305,224.8a1.2,1.2,0,0,0-.2-.5L167.6,303.5c.3,0,.5.3.8.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M305.5,227.4v-.8L170.7,304.3l1,.2Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M304,231.2c.3-.5.8-.8.8-1.3L175,304.8h1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M245.3,188.6l-.5-.6L106,268l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M247.8,190.1l-.5-.5L108.6,269.5l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M250.4,191.4l-.5-.3-138.8,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M252.9,192.9l-.7-.3L113.7,272.3l.8.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M255.5,194.4l-.5-.5-138.7,80,.7.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M258,196l-.7-.5L118.8,275.4l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M260.6,197.2l-.5-.2L121.4,276.9l.7.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M263.1,198.8l-.5-.3L123.9,278.2l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M265.7,200.3l-.5-.2L126.5,279.8l.7.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M268.3,201.8l-.6-.5L129,281.3l.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M270.8,203.4l-.5-.5L131.8,282.8l.6.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M273.4,204.6l-.5-.2L134.1,284.1l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M275.9,206.2l-.5-.5L136.7,285.6l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M278.5,207.7l-.5-.5-138.8,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M281,209l-.5-.3-138.7,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M206.9,166.6l-.7-.5L67.7,246l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M209.5,167.9l-.8-.3-138.4,80,.7.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M212.1,169.4l-.8-.3L72.8,248.8l.5.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M214.6,170.9l-.8-.5-138.4,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M217.2,172.2l-.8-.2L77.9,251.9l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M219.7,173.7l-.7-.2L80.5,253.4l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M222.3,175.3l-.8-.3L83,254.7l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M224.8,176.8l-.5-.5-138.7,80,.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M227.4,178.3l-.8-.5-138.4,80,.7.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M229.9,179.6l-.5-.2L90.7,259.3l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M232.5,181.1l-.8-.2L93.3,260.6l.7.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M235,182.7l-.7-.5L95.8,262.1l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M237.6,184.2l-.8-.5-138.4,80,.7.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M240.2,185.5l-.6-.3-138.7,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M241.9,186.8,103.5,266.5l.8.5,138.4-80Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M171.2,145.9l-.5-.3L32,225.3l.7.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M173.7,147.4l-.7-.5-138.5,80,.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M176.3,149l-.5-.6-138.7,80,.7.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M178.8,150.2l-.7-.2L39.6,229.9l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M181.4,151.8l-.8-.3L42.2,231.2l.7.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M184,153.3l-.8-.5L44.7,232.7l.8.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M186.5,154.8l-.5-.5-138.7,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M189.1,156.1l-.8-.2L49.8,235.8l.8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M191.6,157.6l-.5-.2L52.4,237.1l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M194.2,159.2l-.5-.5L54.9,238.6l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M196.7,160.7l-.5-.5-138.7,80,.8.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M199.3,162l-.8-.3-138.4,80,.7.2Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M201.8,163.5l-.5-.2L62.6,243l.8.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M204.4,165.1l-.5-.6-138.7,80,.7.5Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M159.2,141h-1.3L27.6,216.1a1.8,1.8,0,0,0-.2,1.1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M163,141.8l-.8-.2L27.1,219.5v.7Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M166.1,143.1c-.3,0-.5-.3-.8-.3L27.9,222c0,.3.2.3.2.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M167.9,144.1,29.4,223.8l.5.5,138.5-79.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M133.2,39.8v93.8l149.9,86.5h0l-39.3-77.6-18.5,8.3L191.7,82.6,177,87.7,133.4,6.1V39.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M283.3,221.1l-.5-.4L132.4,133.9V5.5l1.1-.3.3.5,43.5,81.2L192,81.8l.3.7,33.6,67.3,18.5-8.2,39.8,78.7ZM134,133.1l147.7,85.3-37.9-74.9-18.7,8.3L191.2,83.6l-14.7,5.1L134,8.8Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M133.2,6,142,1.4l43.8,81.9L177,87.9Z" transform="translate(-1 -0.4)" />
    <path class="cls-4" d="M134.2,14.9l8.9-4.6,43.8,81.9L178,96.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M176.7,88.8,132.6,6.3c-.2-.3,0-.8.3-1.1L142.3.4l44.6,83.2ZM134.2,6.3l43.1,80.5,7.5-4L141.7,2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M177.3,88.5l-.6-1.3,8.9-4.6,14.5-5.2.7,1.4L192,83.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M200.4,78.2l34,68-8.9,4.6L191.7,82.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-4" d="M200.4,86.8l34,68.1-8.9,4.7L191.7,91.4Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M225.1,151.8,190.6,82.3l10-5.3,34.6,69.5ZM192.6,82.9l33.3,66.8,7.5-4L200.1,78.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M225.8,151.4l-.7-1.2,9-4.7,18.4-8.2.7,1.2-8.9,4.7Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M283.3,220.3l8.7-4.7-39.3-77.7-8.8,4.6Z" transform="translate(-1 -0.4)" />
    <path class="cls-4" d="M277.2,214.8l8.8-4.6-32.2-63.1-8.9,4.7Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M283,221.2l-40-79,10-5.3L293,216Zm-38.1-78.4,38.7,76.5,7.5-4-38.7-76.4Z"
      transform="translate(-1 -0.4)"
    />
    <g>
      <path
        class="cls-2"
        d="M30.3,140.9V129h-.2l-12.4,1L16.5,123h-.1L5,129.6H4.9L2.7,129H2.5v11.8c0,.4.3.6.6.9l11.4,6.7a3.6,3.6,0,0,0,3.2,0l11.6-6.7C30.1,141.7,30.3,141.3,30.3,140.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M16.5,149.7a3.9,3.9,0,0,1-2-.5L3.1,142.4a1.4,1.4,0,0,1-1-1.4V128.7l.3-.2c.1-.2.4-.2.7-.2l1.9.6,11.3-6.5a1.1,1.1,0,0,1,.8,0h.2l1.1,6.6,11.9-1h.1c.4.1.5.4.5.8v12a1.7,1.7,0,0,1-.9,1.4L18.4,149A3.4,3.4,0,0,1,16.5,149.7Zm-13-19.8v11l.2.4L15.2,148a2.8,2.8,0,0,0,2.5,0l11.6-6.7c.3-.2.3-.4.3-.4V129.6l-11.9,1.1h-.2l-.3-.2-1.1-6.2L5.2,130.4H4.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M30.3,128.9l-12.5,1-1.4,4.4V149a3.5,3.5,0,0,0,1.7-.4l11.6-6.7a1.4,1.4,0,0,0,.7-1c-.1,0,0-11.5-.1-12Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M16.5,149.7h-.8V134l1.8-5,.5.2,12.3-1h.1c.4.1.5.4.5.8v12a1.7,1.7,0,0,1-.9,1.4l-11.6,6.8A5.9,5.9,0,0,1,16.5,149.7Zm.6-15.4v14l.6-.3,11.6-6.7c.3-.2.3-.4.3-.4V129.6l-11.4,1.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M4.5,130.7a8.2,8.2,0,0,1,.4-1.1l-2-.6H2.8v11.8c0,.4.3.6.5.9l1.2.6V130.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M5.2,143.6l-2.1-1.3a1.5,1.5,0,0,1-1-1.4V128.6l.3-.3h.7l2.7.8-.2.6-.4,1ZM3.5,129.9v11l.2.4h.2V130Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M14.9,136.8,3.5,130a1.2,1.2,0,0,1,0-2.1l11.7-6.7a3.2,3.2,0,0,1,3,0l11.5,6.7a1.2,1.2,0,0,1,0,2.1L18,136.8A3.4,3.4,0,0,1,14.9,136.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M16.5,137.8a2.9,2.9,0,0,1-1.8-.5L3.1,130.6a2,2,0,0,1-1-1.6,1.8,1.8,0,0,1,1-1.6l11.7-6.7a3.5,3.5,0,0,1,3.7,0L30,127.4a1.9,1.9,0,0,1,0,3.2l-11.8,6.7A2.6,2.6,0,0,1,16.5,137.8Zm.2-16.3-1.2.2L3.7,128.5c-.2.1-.2.4-.2.5s0,.4.2.5l11.5,6.7a2.5,2.5,0,0,0,2.4,0l11.7-6.7a.6.6,0,0,0,0-1l-11.5-6.8Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-2"
      d="M23.8,113.7v39l106.1,61.4V174.9L23.8,113.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M130,214.9h-.4L23.1,153.1v-40l.7-.3.4.2,106.4,61.5v39.9ZM24.6,152.3l104.8,60.6V175.3L24.6,114.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M194.4,137.2,130,174.9l-41.8,24v39.2l42-24.1,64.2-37.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M88.2,238.9l-.7-.4v-40h.4l41.5-23.9.4-.2,64.6-37.9.7.4v40h-.4l-63.9,37.5-.4.2Zm.7-39.4v37.6l40.6-23.4.4-.2L193.8,176V138.4l-63.1,36.9-.4.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M57.4,181.2v39.2l30.8,17.9V199.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M88.2,238.9h-.4l-31.2-18V181l.7-.4h.4l31.2,18v39.8ZM58.1,220.1l29.4,17V199.5L58.1,182.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M54.7,257.5l33.6-19.4v-39L54.7,218.6l-5.3,30Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M54.4,258.5l-.4-.6-5.5-9.3v-.3L54,218.1l.3-.2,33.9-19.6.7.4v40h-.4Zm-4.3-10.1,4.8,8.3,32.8-18.8V200.3L55.3,219Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M54.5,257.5,23.8,239.9v-7.8l30.7,17.8v7.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M54.5,258.3l-.2-.2-31.2-18v-8.6l.7-.4.4.2,31.1,17.9v8.6ZM24.4,239.5l29.5,17v-6.2l-29.5-17Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M54.5,249.7,23.8,231.9l6.7-3.8,30.8,17.8-6.8,3.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M54.5,250.5l-.4-.2L23,232.3v-.8l.4-.2,7.1-4.1.4.2,31.2,18v.8l-.4.2ZM25.1,231.9,54.5,249l5.4-3.2-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M61.3,245.9,30.5,228.1v-7.8l30.8,17.8v7.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M61.3,246.6l-.4-.2L30.1,228.6h-.4v-8.7l.7-.4h.4l31.1,18v8.6ZM31.2,227.7l29.4,17v-6.2l-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M74.7,214.6,44,196.8l6.7-3.8,30.8,17.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M74.7,215.4l-.4-.2-31.1-18v-.8l.4-.2,7.1-4.1.4.2,31.2,18v.8l-.4.2ZM45.3,196.8l29.4,17.1,5.4-3.2-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M81.5,210.7,50.7,192.9v-7.8l30.8,17.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M81.5,211.5l-.4-.2L49.9,193.4v-8.6l.7-.4.4.3,31.1,17.9v8.6ZM51.4,192.6l29.4,17v-6.2l-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M194.4,137.2,88.3,75.8,23.9,113.5l75.4,43.6-48.6,28,30.8,17.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M81.5,203.7l-.4-.3L49.9,185.5v-.8l.3-.3L97.7,157,23.1,114.1v-.8l.3-.3L88.1,75.1l.4.2,106.1,61.3.4.2v.8l-.4.2ZM52,185.2l29.5,17L193,137.3,88.2,76.7l-63.1,37,75.4,43.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M61.3,238.1,30.5,220.3l6.7-3.8L68,234.3l-6.7,3.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M61.3,238.9l-.4-.2-31.2-18v-.8l.4-.2,7-4h.4l31.2,18v.8l-.4.2ZM31.8,220.3l29.5,17,5.4-3.1L37.2,217.1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M68,234.2,37.2,216.4v-7.8L68,226.4Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M68,235l-.4-.2L36.5,216.9v-8.7l.6-.4h.4l31.2,18v8.5ZM37.9,216l29.4,17v-6.2l-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M68,226.4,37.2,208.6l6.8-3.9,30.7,17.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M68.1,227h-.4L36.6,209v-.8l.4-.3,7.1-4.1.4.3L75.7,222v.8l-.4.3ZM38.6,208.6l29.4,17,5.4-3.2L44,205.4Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M74.7,222.4,44,204.6v-7.8l30.7,17.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M74.7,223.2h-.4l-31.1-18v-8.5l.6-.4h.4L75,214.1h.4V223Zm-30.1-19,29.5,17V215L44.6,198Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-4" d="M46.4,153.9l4.3-2.5L36.1,143l-4.4,2.5Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M46.4,154.6h-.3l-14.9-8.6v-.7h.2l4.5-2.7.3.2,14.9,8.6v.6h-.3Zm-13.6-9.1,13.7,7.9,3.3-1.8-13.7-8Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M46.4,153.9v17.2l-14.7-8.5V145.5Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M46.4,171.7h-.3L31.2,163V145.2l.5-.2H32l14.9,8.6v17.7Zm-14.2-9.3L46,170.3v-16l-13.8-7.9Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M50.7,151.6v17.1l-4.3,2.5V154.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M46.4,171.7l-.6-.2V153.7l.3-.2,4.5-2.6.5.3v17.6l-.3.2Zm.5-17.4v16l3.3-1.9V152.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M209.6,271.7v23.5l62.6-37V234.7Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M209.7,295.9l-.6-.4V271.3l.3-.2L272.4,234l.7.4v24.3l-.4.2Zm.6-23.8V294l61.2-36.2V235.9Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M144.4,233.6v23.3l65.2,38.3V271.7Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M209.7,295.9l-.3-.2-65.5-38.6V232.5l66.4,38.6v24.3Zm-64.6-39.4L209,294V272.1l-63.9-37.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M80.1,270.7v23.5l64.5-37.1V233.6Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M80.1,294.9l-.6-.4V270.2l.2-.3,64.9-37.2.6.4v24.3l-.3.3Zm.7-23.9v21.9l63.1-36.3V234.7Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M49.3,252.9v39.2L80,294.2V270.7Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M80.3,294.9H80l-31.4-2.3V252.5l.7-.4.4.2,31.1,17.9v24.2Zm-30.4-3.4,29.5,1.9V271L49.9,254Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M59.9,305.8l20.2-11.6V270.7l-22.9,5.6,4.6,11.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M59.9,306.6l-.6-.5v-.4L61,288.4l-4.6-12.1.4-.6H57l23.3-5.6.5.4v24.4h-.4Zm2.4-18.7.2.4-1.8,16.2,18.8-10.8V271.5l-21.4,5.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M66.7,286.3,35.9,268.5l6.8-3.8,30.7,17.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M66.7,287.1l-.4-.3L35.1,268.9v-.8l.4-.3,7.2-4.1.4.3,31.1,18v.7l-.3.3ZM37.2,268.5l29.5,17,5.4-3.2-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M73.4,282.3,42.7,264.5v-7.8l30.7,17.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M73.4,283.1l-.3-.2-31.2-18v-8.6l.6-.3h.4L74.1,274v8.6Zm-30.2-19,29.4,17.1V275L43.2,257.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M176.2,178.7l-133.7,78,30.8,17.9,71-41,65.2,38.1,62.5-37Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M73.5,275.2H73l-31.1-18v-.8l.4-.2,133.9-78.3.4.3,96.5,56.1v.8l-.3.2L210,272.3h-.5l-64.9-37.8ZM44,256.7l29.4,17.1,71-40.9,65.2,38,61.3-36.2-94.8-55.2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M59.9,305.8,29.2,288v-7.8l30.7,17.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M59.9,306.6h-.3L28.4,288.6V280l.7-.4h.4l31.1,18v8.5Zm-30-19,29.4,17.1v-6.2L29.9,281.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M59.9,298.1,29.2,280.2l6.7-3.8,30.8,17.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M59.9,298.7h-.3l-31.2-18v-.8l.4-.2,7-4.1h.4l31.1,18v.8l-.4.2ZM30.5,280.2l29.4,17.1,5.5-3.2-29.5-17Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M66.7,294.1,35.9,276.3v-7.8l30.8,17.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M66.7,294.9h-.4l-31.2-18v-8.6l.7-.4.4.2,30.7,17.8h.4v8.7Zm-30.1-19,29.4,17v-6.2l-29.4-17Z"
      transform="translate(-1 -0.4)"
    />
    <g id="arrow">
      <polygon id="arrowhead" class="cls-3" points="111.6 1 111.6 17 124.1 10.4 111.6 1" />
      <polyline
        id="arrowline"
        ref="arrowline"
        class="cls-5"
        points="268.6 231.1 231 155.8 213 164.1 172.8 86.3 157.4 88.6 116.8 12.1"
      />
    </g>
    <g id="hand">
      <path
        class="cls-3"
        d="M273.1,202.1h-.4a.8.8,0,0,1-.4-.8V187.3a.9.9,0,0,1,.9-.9h12.3v6.5a4.9,4.9,0,0,1-2.6,3.7l-9.1,5.2A1.1,1.1,0,0,1,273.1,202.1Zm.5-14.3v12.7l8.5-4.9a3.1,3.1,0,0,0,2-2.6v-5.2Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M239.2,164.2l-.5,5.9H240l.5-5.9Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M273,202.4l-.8-.4a23,23,0,0,0-9.9-2.8,57.9,57.9,0,0,1-12-2l-4-1a38.4,38.4,0,0,0-5.1-1c-1.6-.1-2.8-.9-2.9-1.9v-6.6l.6-.2h1.6v-.7l-3.3-1.9a2,2,0,0,1-1.2-1.8v-6l.3-.3h.7l7,1.8c.6.2,1.8.4,1.9,1.3a1.3,1.3,0,0,1-.5,1.1l6.5,1.8a5.7,5.7,0,0,1,3.5.4l.4.2,1.8-1a6.6,6.6,0,0,1,5-.1h.4l1.7-.9a5.8,5.8,0,0,1,5-.1l9.8,5.7,6,.5v6.5a4.9,4.9,0,0,1-2.6,3.7Zm-33.4-9.3c.1.4.8.8,1.7,1a29.3,29.3,0,0,1,5.3.9l3.9,1a72.6,72.6,0,0,0,11.8,2,23.9,23.9,0,0,1,10.4,3l9.1-5.2a3.3,3.3,0,0,0,2-2.7v-5.3l-5.2-.5h-.1l-9.9-5.7a4.1,4.1,0,0,0-3.6.1l-2.3,1.4-1.1-.6a3.6,3.6,0,0,0-3.5.2l-2.4,1.3-1.1-.5a3.5,3.5,0,0,0-2.7-.3h-.4l-7.8-2.4.4-1.7h.1l-.5-.2h-.2l-6.2-1.7v5q0,.3.6.6l4.2,2.5v.5l-.6,1.9h-2C239.6,191.8,239.6,192.9,239.6,193.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M284.6,187.2l-5.6-.5-9.9-5.7a4.4,4.4,0,0,0-4.3.1l-2,1.2-.7-.4a4.4,4.4,0,0,0-4.3.1l-2,1.2-.6-.4a5.3,5.3,0,0,0-3.3-.4l-7.3-2.1v-.8c1.6-.9-.6-1.3-.9-1.3l-7-1.8h-.1v5.8a1.4,1.4,0,0,0,.8,1.2l3.8,2.1h0l-.4,1.5-2,.2v6c.1.6,1.1,1.3,2.3,1.4a29.7,29.7,0,0,1,5.2.9l4,1.1a86.8,86.8,0,0,0,11.9,2,21.8,21.8,0,0,1,10.1,2.9l.4.2,9.5-5.4a4.2,4.2,0,0,0,2.4-3.1v-6.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M273,201.3c0,.1.1.3.2.1l9.1-5.2a4.1,4.1,0,0,0,2.4-3.2v-5.8H273.2c-.1,0-.2.1-.2.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M262.8,176.2l-.7-.4a4.7,4.7,0,0,0-4.3.2l-2,1.2-.6-.4a4.6,4.6,0,0,0-4.4.1l-2,1.2-6.2-3.6a4.7,4.7,0,0,0-4.3.2l-.6.2c-1.2.7-1.3,1.9-.1,2.5l15.3,8.9h-.1L250,186l-6.1-.7h-1.6c-1.7-.1-3.1.5-3.5,1.6v.3c-.3.9.7,1.7,2.2,1.9a45.1,45.1,0,0,1,5.3,1l3.9,1a86.8,86.8,0,0,0,11.9,2,23.6,23.6,0,0,1,10.2,2.9l.4.3,9.5-5.4c2-1.2,2.7-3,2.1-4.5V186a9.5,9.5,0,0,0-4.1-4.1l-11-6.3a4.4,4.4,0,0,0-4.3.1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M248.1,177.5l-.6,1.1,5,2.9.7-1.1Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M252.4,185.4l-.4,1.2,3.4,1.3.5-1.2Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M255.2,176.5l-.7,1.2,3.9,2.2.7-1.1Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M262.2,175.8l-.6,1.1,3,1.8.7-1.2Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M233.4,165.9l-1.1.7,3.2,5.1,1.1-.7Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M227.7,171.6l-.3,1.2,5.9,1.8.4-1.3Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M240.4,178.5H239v5.9h1.4Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M250.3,190.5h-1.4v5.9h1.4Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M268.9,193.8h-1.3v5.9h1.3Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M242.7,188.9h-1.3v5.9h1.3Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M273,196.6l-.8-.4a23,23,0,0,0-9.9-2.8,57.9,57.9,0,0,1-12-2l-4-1a38.4,38.4,0,0,0-5.1-1,3.7,3.7,0,0,1-2.7-1.3,1.7,1.7,0,0,1-.2-1.4v-.3c.4-1.3,2.2-2.1,4.2-2l1.6.2a56.7,56.7,0,0,1,5.8.5l-12.5-7.3a1.9,1.9,0,0,1-1.2-1.7,2,2,0,0,1,1.3-1.8l.4-.4a6.2,6.2,0,0,1,5-.2l5.9,3.5,1.8-1a5.8,5.8,0,0,1,5-.1h.4l1.7-.9a5.8,5.8,0,0,1,5-.1h.4l1.7-.9a5.8,5.8,0,0,1,5-.1l11,6.3a9.7,9.7,0,0,1,4.3,4.5l.2.2c.9,2,0,4-2.4,5.3Zm-30.8-10.9c-1.3,0-2.4.6-2.5,1.1v.7a1.8,1.8,0,0,0,1.6.6,26.8,26.8,0,0,1,5.2.9l4,1.1a86.5,86.5,0,0,0,11.7,2,22.7,22.7,0,0,1,10.5,3l9.1-5.3c1.7-.9,2.4-2.3,1.8-3.5V186a9.2,9.2,0,0,0-3.8-3.8l-11-6.4a3.9,3.9,0,0,0-3.6.2l-2.3,1.3-1.1-.5a3.4,3.4,0,0,0-3.5.1l-2.4,1.3-1.1-.5a3.9,3.9,0,0,0-3.5.1l-2.4,1.3-6.6-3.8a4.1,4.1,0,0,0-3.6.1l-.5.3c-.4.3-.7.5-.7.7a.8.8,0,0,0,.6.5l15.8,9.1-.4,1.1h-.7l-2.7-.4a59.8,59.8,0,0,0-6.1-.7h-1.6C242.3,185.7,242.3,185.7,242.2,185.7Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-4"
      d="M237.1,216.8l-15.2-3.1a23.9,23.9,0,0,0-10.3-.1L170,222.7c-1,.3-1.3,1-.6,2l23.5,25.8a3.7,3.7,0,0,0,3.3,1.1l24.2-5.3a14.5,14.5,0,0,1,6.2.1l15.7,3.2a27.7,27.7,0,0,0,11.8.1l41.8-9.1c1.1-.2,1.4-1,.7-1.9l-23.5-25.9a4.1,4.1,0,0,0-3.3-1.1l-24.2,5.2A22.2,22.2,0,0,1,237.1,216.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M195.8,252.3a5,5,0,0,1-3.3-1.4L169,225.1a2,2,0,0,1-.6-1.9,2.1,2.1,0,0,1,1.5-1.2l41.6-9.1a26.7,26.7,0,0,1,10.5.2l15.2,3a18.4,18.4,0,0,0,8.4.1l24.2-5.1a4.4,4.4,0,0,1,4,1.3l23.5,25.9a2.1,2.1,0,0,1,.5,1.8,1.7,1.7,0,0,1-1.5,1.2l-41.8,9.1a30.4,30.4,0,0,1-12-.1l-15.7-3.2a15.2,15.2,0,0,0-6-.1l-24.2,5.3Zm20.4-38.6a32.7,32.7,0,0,0-4.5.4l-41.5,9.1-.6.3c0,.1,0,.2.3.5l23.5,25.9a3.7,3.7,0,0,0,2.8.9l24.2-5.3a14.8,14.8,0,0,1,6.6.2l15.7,3.1a29.9,29.9,0,0,0,11.5.2l41.9-9.1.5-.3a.5.5,0,0,0-.3-.5l-23.5-25.9a2.9,2.9,0,0,0-2.7-.9l-24.2,5.1a24.8,24.8,0,0,1-9-.1l-15.1-3.1A52.9,52.9,0,0,0,216.2,213.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M283.9,231.5l-8.4-9.3a2.2,2.2,0,0,0-1.3-.6,14.5,14.5,0,0,1-10.5-3.4,1.7,1.7,0,0,0-1.3-.4L248.2,221a20.4,20.4,0,0,1-8.5-.2l-18.2-3.5a15.8,15.8,0,0,0-6.5,0L183.9,224c-.4.1-.5.4-.4.8,1.7,2.2,1.2,4.6-1.3,5.7-.4.1-.4.5-.2.8l9.1,10a1.8,1.8,0,0,0,1.2.5,14.4,14.4,0,0,1,9.4,3.3c.4.3.9.6,1.3.4l14.9-3.3a18.3,18.3,0,0,1,7.7.2l16.1,3.4a19.2,19.2,0,0,0,7.9.1l31.4-6.8C278.6,235.9,279.7,232.5,283.9,231.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M246.7,247a19.4,19.4,0,0,1-4.6-.6L226,243a18.5,18.5,0,0,0-7.4-.1l-14.9,3.3a2.8,2.8,0,0,1-2-.5,12.8,12.8,0,0,0-8.8-3.1,2.6,2.6,0,0,1-1.8-.6L182,231.9a1.5,1.5,0,0,1-.4-1c.2-.4.3-.7.7-.8a3.1,3.1,0,0,0,1.8-1.9,2.9,2.9,0,0,0-.7-2.7,1.2,1.2,0,0,1-.2-1.1,1.4,1.4,0,0,1,.9-.8l31.2-6.7a18.8,18.8,0,0,1,6.7,0l18.2,3.5a20.8,20.8,0,0,0,8.2.2l14.3-3.2a3,3,0,0,1,2,.5,13.2,13.2,0,0,0,9.9,3.3,2.8,2.8,0,0,1,1.9.7l9.3,10.2-1.2.2c-1.9.4-3.1,1.3-3.4,2.5a4.2,4.2,0,0,0,1.3,4l.8.9-32.6,7.1Zm-25.1-5.7a17.7,17.7,0,0,1,4.5.5l16.1,3.5a20,20,0,0,0,7.7.1l30.3-6.6a5.2,5.2,0,0,1-.9-4.4,4.6,4.6,0,0,1,3.3-3l-7.7-8.7-.7-.3a15.3,15.3,0,0,1-11-3.5c-.1-.2-.5-.3-.8-.3l-14.2,3.2a21.9,21.9,0,0,1-8.8-.2l-18.2-3.5a16.1,16.1,0,0,0-6.2,0l-30.9,6.7a4.3,4.3,0,0,1,.8,3.7,3.8,3.8,0,0,1-2.2,2.6l9,9.9a.7.7,0,0,0,.6.3,15.1,15.1,0,0,1,9.9,3.4,1.3,1.3,0,0,0,.8.3l14.9-3.3A12.3,12.3,0,0,1,221.6,241.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M224.3,223c-6.5,1.4-8.1,6.4-3.6,11.3s13.3,7.7,19.7,6.3,8-6.4,3.5-11.3S230.7,221.5,224.3,223Zm13,14.2c-3.9.9-9.5-.9-12.2-3.9s-1.8-6.3,2.2-7.2a14.1,14.1,0,0,1,12.3,4C242.3,233.1,241.3,236.4,237.3,237.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M236.8,241.7c-6.1,0-12.9-2.8-16.8-6.9-2.3-2.5-3.1-5.2-2.3-7.6s3-4.1,6.3-4.9c6.6-1.5,15.7,1.4,20.3,6.5,2.4,2.5,3.2,5.2,2.4,7.6s-3,4.1-6.3,4.9A13.7,13.7,0,0,1,236.8,241.7Zm-9-18.5a18.6,18.6,0,0,0-3.4.4c-2.9.7-4.8,2-5.4,4s.1,4.2,2.1,6.3c4.4,4.8,12.8,7.5,19,6.1,2.9-.7,4.8-2,5.4-4s-.1-4.2-2.1-6.3C239.8,225.7,233.4,223.2,227.8,223.2Zm7.3,14.9a15.4,15.4,0,0,1-10.6-4.3c-1.4-1.7-2.1-3.5-1.6-5s2-2.7,4.3-3.2a15,15,0,0,1,12.9,4.1c1.5,1.7,2.1,3.4,1.6,5s-2,2.6-4.2,3.2Zm-5.7-11.4-2.1.2c-1.7.4-2.8,1.2-3.2,2.3s.2,2.3,1.4,3.7a13.1,13.1,0,0,0,11.6,3.7,3.9,3.9,0,0,0,3.1-2.3c.4-1-.1-2.4-1.3-3.7S232.8,226.7,229.4,226.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M233.9,235.9a9.3,9.3,0,0,1-6.6-2.8,3.9,3.9,0,0,1-1.1-3.3,3.7,3.7,0,0,1,2.8-2.1,9.7,9.7,0,0,1,8.2,2.6,4.1,4.1,0,0,1,1.1,3.3,3.6,3.6,0,0,1-2.8,2.2Zm-3.4-7h-1.2c-.9.3-1.6.7-1.7,1.2a2.4,2.4,0,0,0,.6,2,8.2,8.2,0,0,0,6.9,2.2c.9-.2,1.6-.6,1.7-1.1a2.4,2.4,0,0,0-.7-2A7.3,7.3,0,0,0,230.5,228.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M179.5,229.3l-2-2.3a1.7,1.7,0,0,1-.4-1.5,1.6,1.6,0,0,1,1.2-1.1l2.1-.4.3,1.3-2.1.4-.3.2h.2l1.9,2.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M272.6,220.1l-2-2.3a2.1,2.1,0,0,0-1.9-.5l-2.1.4-.2-1.3,2.1-.4a3,3,0,0,1,3,.9l2,2.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M197.6,247.5a3.6,3.6,0,0,1-2.5-1.1l-2-2.2,1.1-.9,2,2.2a2.2,2.2,0,0,0,1.8.6l2.1-.4.3,1.3-2.1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M285.9,238.8l-.3-1.3,2.2-.4.2-.2h-.1l-2-2.2,1.1-1,1.9,2.3a1.6,1.6,0,0,1,.4,1.6,1.4,1.4,0,0,1-1.2,1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M214.8,231.4a6.8,6.8,0,0,1-.4-5.9c.9-2.4,3.1-4.1,6.7-5.2l.4,1.3c-3.2,1-5,2.5-5.8,4.4s.4,4.7.4,4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M247.9,240.9l-.7-1.2.4.5-.4-.5a5.4,5.4,0,0,0,1.9-6.7l1.2-.5A6.7,6.7,0,0,1,247.9,240.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M199.9,242.5a14.4,14.4,0,0,0-6.4-1.6h-.2l-.3-.3-8.3-9.2.8-.4a3,3,0,0,0,1.7-2.8h1.3a3.9,3.9,0,0,1-1.7,3.7l7,7.8a14.6,14.6,0,0,1,6.7,1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M200.9,240.2l-12-12.8a1.9,1.9,0,0,1-.4-1.7,2,2,0,0,1,1.3-1.2l23.2-5,.3,1.3-23.2,5.1-.3.2s0,.3.2.4l12,12.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M203.1,243.7l-.2-1.3,12.8-2.9c.3-.2.4-.3.4-.4a.9.9,0,0,0-.1-.7l-11.4-12.8,1.1-.9L217,237.5a1.6,1.6,0,0,1,.4,1.8,2,2,0,0,1-1.4,1.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M259.2,238.4,248,225.9a2,2,0,0,1-.4-2,2,2,0,0,1,1.5-1.3l12.7-2.8.2,1.3-12.7,2.8c-.2.1-.4.2-.4.4a.6.6,0,0,0,.2.6l11.2,12.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M252.1,243.7l-.2-1.3,23.2-5.1.2-.2s0-.3-.1-.4l-10.9-11.9,1-.9,11,11.9a1.9,1.9,0,0,1,.4,1.7,2.1,2.1,0,0,1-1.4,1.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M276.1,234.3a3.8,3.8,0,0,1,2.4-4.2l-5.3-5.8a14.7,14.7,0,0,1-8.2-2l.7-1.2a12.5,12.5,0,0,0,7.7,1.7h.4l7.1,7.8-1.1.3c-.1,0-2.7.9-2.3,3.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M207,235.9h-.9a4.4,4.4,0,0,1-3.7-1.3l-3.3-3.6c-1-1-.7-1.9.4-2.2h.9a4.5,4.5,0,0,1,3.7,1.3l3.3,3.5C208.3,234.6,208,235.6,207,235.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M205.5,236.8a5.4,5.4,0,0,1-3.7-1.6l-3.3-3.5a2,2,0,0,1-.6-2.1,1.4,1.4,0,0,1,1.4-1.2l.9-.2a5.4,5.4,0,0,1,4.4,1.6l3.3,3.6a2,2,0,0,1,.7,2.1,1.6,1.6,0,0,1-1.5,1.2h-1.6Zm-4.6-7.5h-1.3l-.4.3a1,1,0,0,0,.4.8l3.3,3.5a3.8,3.8,0,0,0,3,1.2h.9c.2,0,.4-.1.4-.3a1.1,1.1,0,0,0-.4-.8l-3.3-3.5A3.7,3.7,0,0,0,200.9,229.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M265.6,233.6l-.9.2a4.7,4.7,0,0,1-3.7-1.3l-3.3-3.6c-1-1.1-.7-2,.4-2.2l.9-.2a4.7,4.7,0,0,1,3.7,1.3l3.3,3.6C266.9,232.5,266.8,233.5,265.6,233.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M264.1,234.6a5.9,5.9,0,0,1-3.7-1.6l-3.3-3.6a1.9,1.9,0,0,1-.6-2.1c.1-.6.6-1,1.4-1.2h.9a5.1,5.1,0,0,1,4.4,1.6l3.3,3.5a2.2,2.2,0,0,1,.7,2.2,1.7,1.7,0,0,1-1.5,1.1l-.9.2Zm-4.5-7.4h-1.3c-.1,0-.4.1-.4.3a1,1,0,0,0,.4.8l3.3,3.5a3.8,3.8,0,0,0,3.1,1.2h.9c.1,0,.4-.1.4-.3a1,1,0,0,0-.4-.8l-3.3-3.5A3.9,3.9,0,0,0,259.6,227.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M183.7,207.5l-15.3,1.7a25.6,25.6,0,0,0-9.9,3.1l-36.8,21.2a1.1,1.1,0,0,0,0,2l30.2,17.4a4.5,4.5,0,0,0,3.6,0L177,240.5a15.1,15.1,0,0,1,6-1.8l15.9-1.8a27.3,27.3,0,0,0,11.2-3.4l37.1-21.4c1-.5,1-1.4,0-1.9l-30.3-17.6a4.5,4.5,0,0,0-3.6,0l-21.4,12.3A16.9,16.9,0,0,1,183.7,207.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M153.7,254.2a4.2,4.2,0,0,1-2.2-.5l-30.2-17.4a1.8,1.8,0,0,1,0-3.2l36.8-21.2a25.5,25.5,0,0,1,10.2-3.1l15.3-1.7a22,22,0,0,0,8.1-2.5L213,192.3a5.4,5.4,0,0,1,4.3,0l30.3,17.6a1.8,1.8,0,0,1,1.1,1.6,1.9,1.9,0,0,1-1.1,1.6l-37.1,21.3a28.3,28.3,0,0,1-11.4,3.6l-16,1.7a14.7,14.7,0,0,0-5.7,1.7l-21.5,12.4A8.5,8.5,0,0,1,153.7,254.2ZM215.2,193a3.3,3.3,0,0,0-1.5.3l-21.4,12.2a21.8,21.8,0,0,1-8.6,2.7l-15.3,1.7a24.6,24.6,0,0,0-9.6,2.9L122,234a1.2,1.2,0,0,0-.4.4c0,.2.1.3.4.4l30.2,17.5a3.7,3.7,0,0,0,2.9,0l21.5-12.4a12.3,12.3,0,0,1,6.2-1.9l16-1.7a26.9,26.9,0,0,0,10.9-3.3l37.1-21.4a.7.7,0,0,0,.4-.4c0-.1-.1-.3-.4-.4l-30.3-17.5A2.5,2.5,0,0,0,215.2,193Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M232.8,207.4,221.9,201a2,2,0,0,0-1.5,0,13.8,13.8,0,0,1-10.9-.1,2.6,2.6,0,0,0-1.5,0l-12.6,7.3a22.6,22.6,0,0,1-8.1,2.5L169,212.8a18.1,18.1,0,0,0-6.2,1.8l-27.6,16c-.4.3-.4.5-.2.8,2.4,1.7,2.6,4,.6,5.8-.3.3-.2.5.1.8l11.8,6.9a1.9,1.9,0,0,0,1.3.1,13.1,13.1,0,0,1,9.9.3h1.4l13.2-7.7a16.9,16.9,0,0,1,7.4-2.2l16.4-1.6a19.4,19.4,0,0,0,7.6-2.3l27.9-16.1C229.1,213.2,229.1,209.6,232.8,207.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M159.6,246.1a1.3,1.3,0,0,1-.9-.2,13.2,13.2,0,0,0-9.4-.2,2.2,2.2,0,0,1-1.8-.2l-11.8-6.8c-.4-.3-.7-.6-.7-1a1.5,1.5,0,0,1,.4-.9,2.9,2.9,0,0,0,1.2-2.4,2.8,2.8,0,0,0-1.6-2.3,1.6,1.6,0,0,1-.5-1,1,1,0,0,1,.7-.9l27.6-16a15.1,15.1,0,0,1,6.3-1.9l18.3-2.1a21.1,21.1,0,0,0,7.8-2.4l12.7-7.3a2.2,2.2,0,0,1,2.1-.1,13.9,13.9,0,0,0,10.4.1,2.3,2.3,0,0,1,2,.2l11.9,6.8-1.1.5c-1.5,1-2.5,2.2-2.5,3.5s1,2.5,2.5,3.4l1.1.5-28.9,16.7a18.8,18.8,0,0,1-7.9,2.3l-16.4,1.8a16.9,16.9,0,0,0-7.1,2.1l-13.2,7.6A2.5,2.5,0,0,1,159.6,246.1Zm-5.9-2.6a14.2,14.2,0,0,1,5.5,1.1h.8l13.2-7.7a21.2,21.2,0,0,1,7.6-2.2l16.4-1.7a18.4,18.4,0,0,0,7.4-2.3l26.9-15.5a5.1,5.1,0,0,1-2.2-4,5.5,5.5,0,0,1,2.2-4l-10-5.8h-.8a14.8,14.8,0,0,1-11.5-.1,1.1,1.1,0,0,0-.8,0l-12.6,7.3a23,23,0,0,1-8.4,2.6l-18.3,2.1a15.8,15.8,0,0,0-5.9,1.9L135.8,231a4.7,4.7,0,0,1,2,3.3,4.5,4.5,0,0,1-1.3,3.2l11.6,6.7a1.1,1.1,0,0,0,.8,0A17.9,17.9,0,0,1,153.7,243.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M173.3,217.4c-5.7,3.3-5.7,8.6,0,12s15.1,3.3,20.7,0,5.7-8.6,0-12S179.1,214.1,173.3,217.4Zm16.9,9.6a13.4,13.4,0,0,1-12.9,0c-3.6-2.1-3.6-5.4,0-7.3a13.4,13.4,0,0,1,12.9,0C193.6,221.6,193.6,224.9,190.2,227Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M183.7,232.5a21.6,21.6,0,0,1-10.6-2.5c-3.1-1.8-4.7-4.1-4.7-6.6s1.6-4.9,4.7-6.6c5.9-3.5,15.4-3.5,21.3,0,3.1,1.7,4.7,4,4.7,6.6s-1.6,4.8-4.7,6.6A23.8,23.8,0,0,1,183.7,232.5Zm0-16.9a22,22,0,0,0-10,2.3c-2.5,1.5-3.9,3.5-3.9,5.5s1.4,3.9,3.9,5.4c5.6,3.1,14.5,3.1,20.1,0,2.5-1.5,3.9-3.5,3.9-5.4s-1.4-4-3.9-5.5A22.1,22.1,0,0,0,183.7,215.6Zm0,13.7a13.9,13.9,0,0,1-6.8-1.6c-2-1.2-3-2.6-3-4.3s1-3.2,3-4.4a15.5,15.5,0,0,1,13.6,0c2,1.2,3,2.6,3,4.4s-1,3.1-3,4.3A13.9,13.9,0,0,1,183.7,229.3Zm-.1-10.6a13.7,13.7,0,0,0-6.1,1.5c-1.4.9-2.3,2-2.3,3.2s.8,2.2,2.3,3.1a13.4,13.4,0,0,0,12.3,0c1.5-.9,2.4-2,2.4-3.1s-.8-2.3-2.4-3.2A13.5,13.5,0,0,0,183.6,218.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M183.7,227.2a8.5,8.5,0,0,1-4.2-1.1,3.4,3.4,0,0,1-2-2.9,3.7,3.7,0,0,1,2-2.9,10,10,0,0,1,8.6,0,3.4,3.4,0,0,1,2,2.9,3.5,3.5,0,0,1-2,2.9A8.5,8.5,0,0,1,183.7,227.2Zm-.1-6.4a7.5,7.5,0,0,0-3.5.8c-.8.6-1.4,1.1-1.4,1.8s.4,1.1,1.4,1.7a7.5,7.5,0,0,0,7.1,0c.8-.6,1.3-1.1,1.3-1.7s-.4-1.2-1.3-1.8A8,8,0,0,0,183.6,220.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M132.8,237.1l-2.6-1.5a1.5,1.5,0,0,1-1-1.3,1.4,1.4,0,0,1,1-1.3l1.8-1.1.7,1.2-1.9,1.1h0l2.7,1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M218.5,199.9l-2.7-1.5a1.9,1.9,0,0,0-1.8,0l-1.9,1.1-.6-1.2,1.8-1.1a3.6,3.6,0,0,1,3.2,0l2.6,1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M154.3,249.1a2.9,2.9,0,0,1-1.6-.4l-2.6-1.5.7-1.1,2.6,1.4a1.9,1.9,0,0,0,1.8,0l1.9-1.1.6,1.2-1.8,1.1A2.5,2.5,0,0,1,154.3,249.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M236.9,213.7l-.6-1.2,1.8-1,.2-.2h-.2l-2.6-1.4.6-1.2,2.7,1.4a1.7,1.7,0,0,1,.9,1.3,1.5,1.5,0,0,1-.9,1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M166.9,228.4a7.2,7.2,0,0,1-2.3-5.6c.1-2.5,1.7-4.9,4.8-7l.8,1.1c-2.7,1.8-4.1,3.8-4.3,5.9a6.3,6.3,0,0,0,1.9,4.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M201.4,227.3l-1-.9.5.4-.5-.4a5.3,5.3,0,0,0-.3-6.9l1.1-.9A6.8,6.8,0,0,1,201.4,227.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M149.3,243.9l-11.1-6.3.7-.7s1.6-1.5.8-3.1l1.2-.5a3.7,3.7,0,0,1-.6,3.9l9.1,5.3a16.6,16.6,0,0,1,7-.4l-.2,1.3a15.2,15.2,0,0,0-6.6.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M156.4,241l-15.3-8.5a1.7,1.7,0,0,1-.9-1.5,1.4,1.4,0,0,1,.8-1.4l20.6-11.9.6,1.2-20.6,11.8v.3s0,.3.1.3l15.4,8.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M159.6,243.5l-.7-1.1,11.3-6.6a.7.7,0,0,0,.2-.6c0-.1,0-.4-.2-.5L155.5,226l.7-1.2,14.6,8.7a1.9,1.9,0,0,1,.9,1.7,2.1,2.1,0,0,1-.9,1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M211.5,221.5l-14.6-8.6a2,2,0,0,1-.9-1.7,2.4,2.4,0,0,1,.9-1.7l11.3-6.5.6,1.2-11.2,6.5a.6.6,0,0,0,0,1l14.5,8.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M206.2,228.8l-.7-1.2,20.6-11.9a.5.5,0,0,0,.1-.3s0-.2-.1-.2L212,207.3l.7-1.2,14.1,7.9a1.6,1.6,0,0,1,.9,1.4,1.6,1.6,0,0,1-.8,1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M226.2,212.4a4,4,0,0,1,1.1-4.8l-6.7-3.9a14.5,14.5,0,0,1-8.3.6l.2-1.3a12.9,12.9,0,0,0,7.8-.6l.3-.2,9.1,5.3-.9.7c-.2.1-2.4,1.7-1.4,3.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M160.8,235l-.8.4a4.7,4.7,0,0,1-4-.2l-4.2-2.3c-1.2-.7-1.3-1.8-.3-2.3l.8-.4a5.1,5.1,0,0,1,4,.1l4.2,2.4C161.7,233.4,161.8,234.4,160.8,235Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M158.4,236.6a5.2,5.2,0,0,1-2.5-.7l-4.2-2.4a2.4,2.4,0,0,1-1.3-1.8,1.9,1.9,0,0,1,1-1.6l.8-.4a5,5,0,0,1,4.6.1l4.2,2.4a2.6,2.6,0,0,1,1.4,1.8,1.8,1.8,0,0,1-1.1,1.6l-.8.4A5.1,5.1,0,0,1,158.4,236.6Zm-4.3-6.3a4.2,4.2,0,0,0-1.4.3l-.8.4-.4.4c0,.1.2.4.7.7l4.2,2.3a3.5,3.5,0,0,0,3.3.2l.8-.4c.2,0,.4-.3.4-.4s-.1-.4-.6-.7l-4.3-2.4A10.6,10.6,0,0,0,154.1,230.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M216.1,215l-.8.4a4.4,4.4,0,0,1-4-.1l-4.2-2.4c-1.2-.6-1.3-1.7-.3-2.2l.8-.4a5.1,5.1,0,0,1,4,.1l4.2,2.4C216.9,213.5,217,214.5,216.1,215Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M213.6,216.6a4.9,4.9,0,0,1-2.5-.6l-4.3-2.4a2.7,2.7,0,0,1-1.3-1.9,1.8,1.8,0,0,1,1.1-1.5l.8-.4a5,5,0,0,1,4.6.1l4.2,2.4a2.4,2.4,0,0,1,1.3,1.8,1.9,1.9,0,0,1-1,1.6l-.9.4A4.2,4.2,0,0,1,213.6,216.6Zm-4.2-6.2a4.2,4.2,0,0,0-1.4.3l-.8.4c-.1,0-.4.2-.4.4s.2.4.7.6l4.2,2.4a3.5,3.5,0,0,0,3.3.1l.8-.4a.4.4,0,0,0,.4-.3c0-.2-.1-.4-.6-.7l-4.3-2.4A12.9,12.9,0,0,0,209.4,210.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M178.1,280.9c-1.6-2-3.2-1.6-7.4-2.5a24.5,24.5,0,0,0-11.1.1c-3.6.9-5.8,1.6-7.3,3.2l-1.9,1v4h0c.1,2.7,2.2,5.2,6.6,7a21.4,21.4,0,0,0,13.7,1c6.4-1.6,9.6-4.8,9.7-8.1h0v-3.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M165.4,296.1a23.1,23.1,0,0,1-8.6-1.7c-4.5-1.9-7-4.5-7-7.7h0v-4.4l2.1-1.2c1.8-1.8,4.1-2.5,7.6-3.3a24,24,0,0,1,11.3-.1,19.8,19.8,0,0,0,3.1.5c2.2.4,3.5.6,4.7,2.1l2.6,2v4.4c-.1,3.8-3.9,7.1-10.3,8.7A20.3,20.3,0,0,1,165.4,296.1Zm-14.4-13v3.6c.1,2.6,2.3,4.9,6.2,6.5a21.8,21.8,0,0,0,13.4.9c5.6-1.3,9.1-4.2,9.2-7.4h0v-3.5l-2.3-1.8c-.9-1.2-1.8-1.3-3.9-1.7l-3-.6a25.1,25.1,0,0,0-10.9.2c-3.7.9-5.5,1.4-7,3h-.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M176.1,276.5c5.9,3.5,5.9,9,0,12.3s-15.4,3.4-21.4,0-5.9-9,0-12.3S170.3,273.1,176.1,276.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M165.5,292.1a22.8,22.8,0,0,1-10.9-2.6c-3.1-1.7-4.8-4.2-4.8-6.8s1.7-5,4.8-6.7c6.1-3.5,16-3.5,22,0,3.1,1.7,4.8,4.2,4.8,6.7s-1.7,5.1-4.8,6.8A23.6,23.6,0,0,1,165.5,292.1Zm0-17.4a20.4,20.4,0,0,0-10.3,2.5c-2.6,1.6-4.1,3.6-4.1,5.5s1.5,4.1,4.1,5.6c5.7,3.3,15,3.3,20.8,0,2.6-1.6,4.1-3.6,4.1-5.6s-1.5-4-4.1-5.5A22,22,0,0,0,165.5,274.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M172.9,278.9a18.4,18.4,0,0,0-14.9,0c-4.1,2.1-4.1,5.4,0,7.5a17.6,17.6,0,0,0,14.9,0C177,284.5,177,281,172.9,278.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M165.5,288.7a18.1,18.1,0,0,1-7.8-1.6c-2.2-1.2-3.4-2.6-3.4-4.4s1.2-3.3,3.4-4.3c4.3-2.1,11.3-2.1,15.5,0,2.2,1.2,3.4,2.6,3.4,4.3s-1.2,3.3-3.4,4.4A17.1,17.1,0,0,1,165.5,288.7Zm0-10.6a17.6,17.6,0,0,0-7.1,1.5c-1.7.9-2.8,2-2.8,3.1s1,2.3,2.8,3.2a17.8,17.8,0,0,0,14.3,0c1.7-.9,2.7-2,2.7-3.2s-.9-2.2-2.7-3.1A15.5,15.5,0,0,0,165.5,278.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M172.9,281.2a17.6,17.6,0,0,0-14.9,0,7.5,7.5,0,0,0-2.9,2.6,5.8,5.8,0,0,0,2.9,2.6,17.6,17.6,0,0,0,14.9,0,6.8,6.8,0,0,0,2.9-2.6A6.8,6.8,0,0,0,172.9,281.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M165.5,288.7a18.1,18.1,0,0,1-7.8-1.6,6.8,6.8,0,0,1-3.1-2.9l-.2-.3.2-.2a6.3,6.3,0,0,1,3.1-2.9c4.3-2.1,11.3-2.1,15.5,0a7.1,7.1,0,0,1,3.2,2.9v.5a6.6,6.6,0,0,1-3.2,2.9A17.1,17.1,0,0,1,165.5,288.7Zm-9.6-4.9a4.5,4.5,0,0,0,2.4,2,17.6,17.6,0,0,0,14.2,0,4.9,4.9,0,0,0,2.4-2,4.5,4.5,0,0,0-2.4-2,17.6,17.6,0,0,0-14.2,0A6.1,6.1,0,0,0,155.9,283.8Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M174.5,290.3h-1v3.3h1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M153.1,287.5h-1v3.3h1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M167.4,277.6h-1.1v2.1h1.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M157.7,281.6v1.8l2.6.9,1.1-1.8,8.8,5a8.6,8.6,0,0,0,2.1-.7l.9-.5v-1.8l-11.6-4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M170.2,288l-8.6-4.9-1.2,1.9-3.2-1.2v-2.5l4.4-2.4,12.1,5.2v2.3l-1.2.7-2.2.8Zm-8.9-6.2.3.2,8.6,5a9.6,9.6,0,0,0,1.8-.7l.7-.4v-1.2l-11.1-4.6-3.5,1.9v1.1l1.8.7,1-1.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M161.4,280.6l-1.1,1.9-2.6-.9,1.8-2.7,2.2-1.3,11.6,6.7-2.6,1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M170.7,286.6l-9.1-5.3-1.2,1.8-3.4-1.3,2.1-3.3,2.6-1.4,12.3,7v.6Zm-9.4-6.5h.3l9,5.2,1.5-.9-10.5-6.1-1.9,1-1.2,2,1.5.6,1-1.6Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M172.7,290.8h-1.1v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M182,265.6c-1.6-2-3.1-1.6-7.4-2.5a24,24,0,0,0-11,.1c-3.6.9-5.9,1.6-7.3,3.2l-2,1v4h0c.1,2.7,2.3,5.2,6.6,7a20.8,20.8,0,0,0,13.7.9c6.5-1.5,9.7-4.7,9.8-8h0v-3.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M169.4,280.9a21,21,0,0,1-8.6-1.7c-4.5-1.9-7-4.5-7-7.7h0V267l2.1-1.1c1.7-1.9,4.1-2.6,7.5-3.3a23.2,23.2,0,0,1,11.4-.2,20.7,20.7,0,0,0,3,.5c2.3.4,3.6.6,4.8,2.2l2.6,1.9v4.4c-.1,3.8-4,7.1-10.3,8.7A20.9,20.9,0,0,1,169.4,280.9ZM155,268v3.5c.1,2.7,2.2,4.9,6.2,6.5a21.5,21.5,0,0,0,13.3.9c5.7-1.3,9.1-4.2,9.2-7.4h0V268l-2.2-1.9c-.9-1.2-1.8-1.3-4-1.7l-3-.5a23.2,23.2,0,0,0-10.8.1c-3.7.9-5.6,1.5-7,3v.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M169.4,276.1c8.3,0,15-3.9,15-8.7s-6.7-8.7-15-8.7-15.1,3.9-15.1,8.7S161.1,276.1,169.4,276.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M169.4,276.8a22.9,22.9,0,0,1-11-2.6c-3-1.7-4.7-4.3-4.7-6.8s1.7-5,4.7-6.7c6.1-3.6,16-3.6,22,0,3.1,1.7,4.8,4.2,4.8,6.7s-1.7,5.1-4.8,6.8A21.6,21.6,0,0,1,169.4,276.8Zm0-17.3a20.2,20.2,0,0,0-10.3,2.5c-2.7,1.6-4.1,3.6-4.1,5.6s1.4,4.1,4.1,5.5c5.6,3.3,14.9,3.3,20.7,0,2.6-1.6,4.1-3.6,4.1-5.5s-1.5-4.1-4.1-5.6A20.8,20.8,0,0,0,169.4,259.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M176.9,263.7a18.4,18.4,0,0,0-14.9,0c-4.1,2.2-4.1,5.4,0,7.6a18.4,18.4,0,0,0,14.9,0C181,269.1,181,265.9,176.9,263.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M169.4,273.5a17.5,17.5,0,0,1-7.8-1.6c-2.3-1.2-3.5-2.6-3.5-4.3s1.2-3.3,3.5-4.4c4.2-2.1,11.2-2.1,15.4,0,2.3,1.2,3.4,2.7,3.4,4.4s-1.1,3.3-3.4,4.3A16.1,16.1,0,0,1,169.4,273.5Zm0-10.7a16.2,16.2,0,0,0-7.2,1.5c-1.7.9-2.7,1.9-2.7,3.1s.9,2.3,2.7,3.2a17.8,17.8,0,0,0,14.3,0c1.7-.9,2.8-2,2.8-3.2s-1-2.2-2.8-3.1A15.8,15.8,0,0,0,169.4,262.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M176.9,266a18.4,18.4,0,0,0-14.9,0,6.8,6.8,0,0,0-2.9,2.6,5.9,5.9,0,0,0,2.9,2.7,18.4,18.4,0,0,0,14.9,0,7.7,7.7,0,0,0,2.9-2.7A7.5,7.5,0,0,0,176.9,266Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M169.4,273.5a17.5,17.5,0,0,1-7.8-1.6,6.6,6.6,0,0,1-3.2-2.9v-.5a6.1,6.1,0,0,1,3.2-2.9c4.2-2.1,11.2-2.1,15.4,0a6.6,6.6,0,0,1,3.2,2.9v.5a6.1,6.1,0,0,1-3.2,2.9A16.1,16.1,0,0,1,169.4,273.5Zm-9.5-4.9a4.2,4.2,0,0,0,2.3,2,17.8,17.8,0,0,0,14.3,0,4.9,4.9,0,0,0,2.4-2,4.9,4.9,0,0,0-2.4-2,18.7,18.7,0,0,0-14.3,0A5.8,5.8,0,0,0,159.9,268.6Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M178.3,275.1h-1v3.3h1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M157.1,272.3H156v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M171.3,262.3h-1v2.1h1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M161.7,266.4v1.8l2.5.9,1.2-1.8,8.7,5a10.5,10.5,0,0,0,2.1-.6l.9-.6v-1.8l-11.6-4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M174,272.8l-8.6-4.8-1.2,1.8-3.2-1.2v-2.5l4.4-2.4,12.1,5.2v2.4l-1.1.6-2.3.8Zm-8.7-6.2.2.2,8.6,5a6.2,6.2,0,0,0,1.9-.7l.6-.4v-1.2l-11.1-4.7-3.4,1.8v1.2l1.7.7,1.1-1.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M165.4,265.5l-1.2,1.8-2.5-.9,1.7-2.7,2.3-1.3,11.6,6.7-2.7,1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M174.5,271.3l-9.1-5.3-1.2,1.8-3.4-1.3,2.1-3.3,2.6-1.4,12,7,.4.3-.5.4Zm-9.2-6.5h.2l9,5.2,1.6-1-10.6-6-1.8,1-1.2,2,1.5.5,1-1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M176.5,275.6h-1.1v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M267,274c-1.6-1.9-3.1-1.5-7.4-2.5a22.7,22.7,0,0,0-11,.2c-3.6.9-5.9,1.5-7.3,3.1l-2,1.1V280c.1,2.6,2.3,5.1,6.6,7a21.5,21.5,0,0,0,13.7.9c6.5-1.6,9.7-4.8,9.8-8.1h0v-3.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M254.4,289.2a21,21,0,0,1-8.6-1.7c-4.5-1.9-7-4.5-7-7.7h0v-4.3l2.1-1.2c1.7-1.9,4.1-2.5,7.5-3.3a23.2,23.2,0,0,1,11.4-.2l3,.6c2.2.4,3.6.5,4.8,2.1l2.6,2v4.3c-.1,3.8-4,7.1-10.3,8.7A20.9,20.9,0,0,1,254.4,289.2ZM240,276.3v3.5c.1,2.7,2.2,4.9,6.2,6.5a21.5,21.5,0,0,0,13.3.9c5.7-1.3,9.1-4.2,9.2-7.4h0v-3.4l-2.2-1.9c-.9-1.2-1.8-1.3-4-1.7a26.4,26.4,0,0,1-3-.5,23.2,23.2,0,0,0-10.8.1c-3.7.9-5.6,1.5-7,3.1h-.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M265,269.7c6,3.4,6,9,0,12.3s-15.4,3.4-21.3,0-6-9,0-12.3S259.2,266.4,265,269.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M254.5,285.3a23.3,23.3,0,0,1-11-2.7c-3-1.7-4.7-4.2-4.7-6.7s1.7-5,4.7-6.8c6.1-3.5,16-3.5,22.1,0,3,1.8,4.7,4.3,4.7,6.8s-1.7,5-4.7,6.7A24,24,0,0,1,254.5,285.3Zm0-17.5a20.4,20.4,0,0,0-10.3,2.5c-2.6,1.6-4.1,3.6-4.1,5.6s1.5,4.1,4.1,5.5c5.7,3.3,14.9,3.3,20.7,0,2.7-1.6,4.1-3.5,4.1-5.5s-1.4-4.1-4.1-5.6A21.3,21.3,0,0,0,254.5,267.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M261.9,272.2a18.4,18.4,0,0,0-14.9,0c-4.1,2.1-4.1,5.4,0,7.5a18.4,18.4,0,0,0,14.9,0C266,277.6,266,274.2,261.9,272.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M254.5,281.8a17.5,17.5,0,0,1-7.8-1.6c-2.2-1.2-3.4-2.6-3.4-4.3s1.2-3.3,3.4-4.4c4.2-2.1,11.2-2.1,15.4,0,2.3,1.2,3.5,2.7,3.5,4.4s-1.2,3.3-3.5,4.3A16.7,16.7,0,0,1,254.5,281.8Zm0-10.5a17.3,17.3,0,0,0-7.1,1.4c-1.8.9-2.8,2-2.8,3.2s.9,2.2,2.8,3.1a17.6,17.6,0,0,0,14.2,0c1.7-.9,2.8-1.9,2.8-3.1s-.9-2.3-2.8-3.2A18,18,0,0,0,254.5,271.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M261.9,274.4a18.4,18.4,0,0,0-14.9,0,6.4,6.4,0,0,0-2.9,2.7,5.8,5.8,0,0,0,2.9,2.6,18.4,18.4,0,0,0,14.9,0,7.5,7.5,0,0,0,2.9-2.6A5.9,5.9,0,0,0,261.9,274.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M254.5,281.8a17.5,17.5,0,0,1-7.8-1.6,7.1,7.1,0,0,1-3.2-2.9v-.5a6.6,6.6,0,0,1,3.2-2.9c4.2-2.1,11.2-2.1,15.4,0a6.6,6.6,0,0,1,3.2,2.9v.5a6.1,6.1,0,0,1-3.2,2.9A16.7,16.7,0,0,1,254.5,281.8Zm-9.6-4.9a4.2,4.2,0,0,0,2.3,2,17.8,17.8,0,0,0,14.3,0,4.9,4.9,0,0,0,2.4-2,4.4,4.4,0,0,0-2.4-1.9,17.8,17.8,0,0,0-14.3,0A7.7,7.7,0,0,0,244.9,276.9Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M263.5,283.4h-1.1v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M242.1,280.6H241v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M256.3,270.7h-1v2.1h1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M246.7,274.8v1.9l2.5.9,1.2-1.9,8.7,5.1,2.1-.7.9-.5v-1.9l-11.6-4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M259,281.2l-8.6-4.9-1.2,1.8-3.2-1.2v-2.5l4.4-2.3,12.1,5.1v2.4l-1.1.6-2.3.8Zm-8.7-6.2h.2l8.6,5a6.2,6.2,0,0,0,1.9-.7l.6-.4v-1.1l-11.1-4.7-3.4,1.9v1.2l1.7.6,1.1-1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M250.4,273.8l-1.2,1.8-2.5-.9,1.7-2.6,2.3-1.4,11.6,6.8-2.7,1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M259.5,279.7l-9.1-5.3-1.2,1.9-3.4-1.3,2.1-3.3,2.6-1.5,12.3,7v.7Zm-9.2-6.5.2.2,9,5.1,1.6-.9-10.6-6.1-1.8,1.1-1.2,2,1.4.5,1.1-1.6Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M261.5,283.9h-1.1v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M151,199.5c-1.6-2-3.2-1.6-7.4-2.5a24.5,24.5,0,0,0-11.1.1c-3.5.9-5.8,1.6-7.2,3.2l-2,1v4h0c.1,2.6,2.2,5.2,6.6,7a21.5,21.5,0,0,0,13.7.9c6.5-1.6,9.7-4.7,9.8-8v-4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M138.3,214.8a22.2,22.2,0,0,1-8.5-1.7c-4.5-1.9-7-4.5-7-7.7h0v-4.4l2.1-1.2c1.7-1.8,4.1-2.5,7.5-3.3a24.4,24.4,0,0,1,11.4-.1,18.7,18.7,0,0,0,3,.5c2.2.4,3.6.6,4.7,2.1l2.7,2v4.4c-.1,3.8-4,7.1-10.3,8.7A21.6,21.6,0,0,1,138.3,214.8Zm-14.3-13v3.6c.1,2.6,2.2,4.9,6.2,6.5a21.5,21.5,0,0,0,13.3.9c5.7-1.3,9.1-4.2,9.2-7.4h0v-3.5l-2.2-1.8c-.9-1.2-1.9-1.3-4-1.7l-3-.6a24.6,24.6,0,0,0-10.8.2c-3.7.9-5.6,1.4-7,3h-.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M138.5,210.2c8.3,0,15-3.9,15-8.8s-6.7-8.7-15-8.7-15.1,3.9-15.1,8.7S130.2,210.2,138.5,210.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M138.5,210.8a23.2,23.2,0,0,1-11-2.6c-3-1.7-4.7-4.2-4.7-6.8s1.7-5,4.7-6.7c6.1-3.6,16-3.6,22.1,0,3,1.7,4.7,4.2,4.7,6.7s-1.7,5.1-4.7,6.8A24.2,24.2,0,0,1,138.5,210.8Zm0-17.4a20.4,20.4,0,0,0-10.3,2.5c-2.7,1.6-4.1,3.6-4.1,5.5s1.4,4.1,4.1,5.6c5.7,3.3,14.9,3.3,20.7,0,2.6-1.6,4.1-3.6,4.1-5.6s-1.5-4-4.1-5.5A21.3,21.3,0,0,0,138.5,193.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M145.9,197.6c-4.1-2.1-10.9-2.1-14.9,0s-4.1,5.4,0,7.5,10.8,2.1,14.9,0S150,199.7,145.9,197.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M138.5,207.4a17.5,17.5,0,0,1-7.8-1.6c-2.3-1.2-3.4-2.6-3.4-4.4s1.1-3.3,3.4-4.3c4.2-2.1,11.2-2.1,15.4,0,2.3,1.2,3.5,2.6,3.5,4.3s-1.2,3.3-3.5,4.4A17,17,0,0,1,138.5,207.4Zm0-10.7a17,17,0,0,0-7.1,1.4c-1.8,1-2.8,2-2.8,3.2s.9,2.3,2.8,3.2a17.6,17.6,0,0,0,14.2,0c1.7-.9,2.8-2,2.8-3.2s-.9-2.2-2.8-3.2A18,18,0,0,0,138.5,196.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M145.9,199.9c-4.1-2.2-10.9-2.2-14.9,0a6.8,6.8,0,0,0-2.9,2.6c.3.9,1.3,1.8,2.9,2.6,4,2.2,10.8,2.2,14.9,0a8.3,8.3,0,0,0,2.9-2.6A8.3,8.3,0,0,0,145.9,199.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M138.5,207.4a17.5,17.5,0,0,1-7.8-1.6,7.1,7.1,0,0,1-3.2-2.9v-.5a6.6,6.6,0,0,1,3.2-2.9c4.2-2.1,11.2-2.1,15.4,0a6.6,6.6,0,0,1,3.2,2.9v.5a6.1,6.1,0,0,1-3.2,2.9A17,17,0,0,1,138.5,207.4Zm-9.7-4.9a4.5,4.5,0,0,0,2.4,2,17.8,17.8,0,0,0,14.3,0,4.2,4.2,0,0,0,2.3-2,3.9,3.9,0,0,0-2.3-2,17.8,17.8,0,0,0-14.3,0A5.4,5.4,0,0,0,128.8,202.5Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M147.5,209h-1.1v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M126.1,206.2H125v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M140.3,196.2h-1v2.1h1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M130.7,200.3v1.8l2.5.9,1.2-1.8,8.7,5a7.4,7.4,0,0,0,2.1-.7l.9-.5v-1.8l-11.6-4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M143,206.7l-8.6-4.9-1.2,1.9-3.2-1.2V200l4.4-2.4,12.1,5.2v2.3l-1.2.7-2.2.8Zm-8.7-6.2.2.2,8.6,5a7.5,7.5,0,0,0,1.8-.7l.7-.4v-1.2l-11.1-4.7-3.4,1.8v1.2l1.7.7,1.1-1.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M134.4,199.3l-1.2,1.9-2.5-.9,1.7-2.7,2.3-1.3,11.6,6.7-2.7,1.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M143.5,205.3l-9.1-5.3-1.2,1.8-3.4-1.3,2.1-3.3,2.6-1.4,12.2,7v.6l-.3.2Zm-9.2-6.6h.2l9,5.2,1.6-1-10.6-6-1.8,1-1.2,2,1.4.5,1.1-1.6Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M145.5,209.5h-1.1v3.3h1.1Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M88.3,244.9l-.2-.2-15.5-8.9v-.7h.3l16.9-9.8H90l15.5,9v.7h-.3Zm-14.1-9.4,14.3,8.2,15.5-9-14.2-8.2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M88.3,244.2v3.2l16.7-9.5v-3.2Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M88.3,248l-.5-.2v-3.7l.3-.2,16.9-9.7.5.2v3.7l-.3.2Zm.6-3.4v2l15.5-9v-2Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M73.1,235.5v3.2l15.2,8.8v-3.2Z" transform="translate(-1 -0.4)" />
    <g>
      <path
        class="cls-4"
        d="M88.3,244.2l-15.2-8.8,16.7-9.5,15.2,8.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M88.3,248h-.2l-15.5-9v-3.7l.5-.2h.3l15.5,9v3.7Zm-14.6-9.6,14.2,8.2v-2l-14.2-8.2Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <g class="barchartseed">
      <path
        class="cls-4"
        d="M97.6,275.4l23.5-13.6-5.9-3.5L91.8,271.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M97.6,276h-.3l-6.1-3.6v-.6l.3-.2,23.7-13.7h.3l6.1,3.6v.7h-.3Zm-4.8-3.9,4.9,2.7,22.6-13-4.9-2.8Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M97.6,275.4v18.7l-5.8-3.3V272.1Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M97.6,294.6h-.3l-6.1-3.4V271.8l.6-.3.2.2,6.1,3.4v19.3Zm-5.3-4.2,4.9,2.8V275.6l-4.9-2.8Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M121.2,261.8v18.7L97.7,294.1V275.4Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M97.6,294.6l-.6-.2V275.1h.3l23.9-13.8.5.3v19.3h-.2Zm.5-19v17.6l22.6-13.1V262.6Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-4" d="M119.9,275.4l6.6-4-2.9-1.7-6.8,3.9Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M119.9,276h-.4l-3.2-1.9v-.5h.3l7-4.1.2.2,3.2,1.9v.5l-.3.2-6.6,3.8Zm-2-2.4,1.8,1.1,5.7-3.3-1.8-1.1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M119.9,275.4v9.3h-.2l-2.9-1.7v-9.4Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M119.7,285.3l-.2-.2-2.8-1.6h-.4V273.4l.5-.3h.3l3.2,1.9V285Zm-2.3-2.6,1.8,1.1v-8.2l-1.8-1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M126.5,271.4v9.4l-6.6,3.9v-9.3Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M119.9,285.3l-.6-.3v-9.8l.3-.2,6.9-4.1.5.2V281l-.3.2Zm.4-9.7v8.2l5.6-3.3v-8.2Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path class="cls-4" d="M219.8,283.5l-2.9-1.7,9.7-5.7,2.9,1.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M219.8,284.1l-.3-.2-3.2-1.8v-.7h.3l10-5.8h.3l3.2,1.9v.6l-.3.2Zm-1.9-2.3,1.9,1.1,8.8-5-1.8-1.1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M219.8,283.5V295l9.7-5.7V277.9Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M219.8,295.5l-.5-.2v-12l.2-.2,10.2-5.8.5.3v12h-.3Zm.5-11.7v10.3l8.8-5V278.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M216.9,281.8v11.5l2.9,1.7V283.5l-2.9-1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M219.8,295.5h-.3l-3-1.8v-12l.5-.3h.3l3.1,1.9v12Zm-2.4-2.5,1.9,1.1V283.8l-1.9-1.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M229.9,283.4l-.4-.7.3.3h-.4v-4.1h.8C230.1,283.3,230.1,283.3,229.9,283.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M47.3,109.1,67.7,101l-7,13.7a31.7,31.7,0,0,1-10.5-3.5A24.3,24.3,0,0,1,47.3,109.1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M67.7,115.4V101.1l5.1,14Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M61.3,114.7H60.1v8.7h1.2Z" transform="translate(-1 -0.4)" />
    <g id="pie">
      <path
        class="cls-3"
        d="M93.2,109.6v.4c-.1,3.9-2.8,7.5-7.5,10.3-9.9,5.6-25.9,5.6-35.8,0a16,16,0,0,1-3-2.3h-.3v-9.3l8.7-1.6L45,104.4h-.4V94.8l23.4-2h.3l3.4,2.3a33.3,33.3,0,0,1,13.7,3.8,19.8,19.8,0,0,1,3.5,2.4l3.8-.7h.2l.6.4ZM45.7,95.7v7.7l12.5,3.3h.6v1.1l-10.9,1.9v7.8a16.5,16.5,0,0,0,2.7,1.9c9.5,5.5,24.9,5.4,34.4,0,4.5-2.7,7-6,7-9.7v-7.9l-3.3.7h-.2l-.3-.2a13.1,13.1,0,0,0-3.4-2.4,34.4,34.4,0,0,0-13.5-3.7l-3.4-2.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M45.2,95.1,68,93.2l3.3,2.3a34.2,34.2,0,0,1,13.6,3.8l3.6,2.4,4-.8v8.6c0,3.6-2.3,7.2-7.2,10.1-9.6,5.7-25.5,5.7-35.1,0a12.7,12.7,0,0,1-2.9-2.1v-8.6l10.8-2-12.9-3.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M67.7,101,45.2,95.1a18.4,18.4,0,0,1,7.1-5.3c9.6-4.4,23.8-4.1,32.6.9s10.2,14.8.4,20.5-25.5,5.6-35.1,0a24.3,24.3,0,0,1-2.9-2.1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M67.7,101v14.3a41.4,41.4,0,0,1-7-.6Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M51.8,112.1v8.6a17.5,17.5,0,0,1-4.9-3.1l.2-8.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M68.4,115.9h-.7a34.6,34.6,0,0,1-7.1-.6l-.8-.2,7.4-14.4.3-.4.9.3Zm-1.3-1.2V103.6l-5.4,10.7A45.6,45.6,0,0,0,67.1,114.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M73.5,115.5l-.7.2a46.1,46.1,0,0,1-5.2.2h-.7V100.5l1.1-.2Zm-1.7-1-3.5-9.9v10.1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M88.1,109.4H86.9v8.7h1.2Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M85.3,111.6H84.1v8.7h1.2Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M51.1,96.6H49.9v8.8h1.2Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M93.2,100.9c0,4.1-2.6,7.9-7.5,10.8-9.9,5.7-25.9,5.7-35.8,0a32.1,32.1,0,0,1-3-2.1l-.3-.3.2-.6,19-7.6L44.9,95.7h-.3v-.9A20.4,20.4,0,0,1,52,89.1c9.9-4.5,24.2-4.1,33.2,1a18.5,18.5,0,0,1,6.2,5.4A10,10,0,0,1,93.2,100.9Zm-25.3-.6.4.2v.9l-20,7.9,2,1.3c9.5,5.6,25,5.5,34.5,0,4.4-2.6,7-6,7-9.6s-2.7-7.1-7.3-9.8c-8.7-4.8-22.6-5.1-32.1-.8a18.8,18.8,0,0,0-6.3,4.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M61,115.4h-.4a32.9,32.9,0,0,1-10.7-3.7l-3-2.1-.3-.2.2-.6,20.7-8.2.4-.2.5.7Zm-10.6-4.8a32.2,32.2,0,0,0,9.9,3.5l6.1-11.9-17.9,7.1Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-2"
      d="M180.8,124.1V57.3h-.1l-15,1.3-1.4-8.3h-.1l-13.8,7.9h-.2l-2.6-.8c-.1,0-.1,0-.1.2v66.6a1.6,1.6,0,0,0,.6,1.2l14,8.2a4.2,4.2,0,0,0,3.8,0l14.3-8.2A1.4,1.4,0,0,0,180.8,124.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M164,134.7a4.8,4.8,0,0,1-2.3-.7l-14-8.2a2.1,2.1,0,0,1-1-1.6V57.5a1.2,1.2,0,0,1,.2-.7c.3-.1.4-.3.7-.1l2.4.6,13.7-7.9a1.1,1.1,0,0,1,.8,0h.2l1.4,8.1,14.6-1.3h.1a.8.8,0,0,1,.6.8V124a2.1,2.1,0,0,1-1.1,1.7l-14.2,8.2A2.9,2.9,0,0,1,164,134.7ZM148,58.2v65.9a.6.6,0,0,0,.4.5l14,8.2a3.4,3.4,0,0,0,3.1,0l14.3-8.2a.6.6,0,0,0,.4-.6h0V57.7L165.5,59H165L163.7,51l-13.5,7.6h-.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M180.7,57.2l-15,1.3L164,63.7V134a3.2,3.2,0,0,0,1.9-.5l14.3-8.2c.5-.3.6-.8.8-1.2s-.2-66.3-.3-66.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M164,134.7h-.8V63.4l1.9-5.9.6.2,15-1.3h.1a.8.8,0,0,1,.6.8V124a2,2,0,0,1-1.1,1.8L166.1,134A3.3,3.3,0,0,1,164,134.7Zm.6-70.9v69.5a1.7,1.7,0,0,0,1.1-.4l14.2-8.1a.8.8,0,0,0,.4-.7V57.8l-14.1,1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M149.4,59.3A8.7,8.7,0,0,0,150,58l-2.5-.7c-.2,0-.2,0-.2.2v66.6a1.7,1.7,0,0,0,.7,1.2l1.4.8V59.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M150.1,127.3l-2.4-1.5a2.1,2.1,0,0,1-1-1.6V57.5a1.2,1.2,0,0,1,.2-.7c.3-.1.6-.3.7-.1l3.2.9-.3.6c-.1.6-.4,1-.4,1.2ZM148,58.2v65.9a.6.6,0,0,0,.4.5l.4.3V59l.2-.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M162.1,66.7,148,58.5a1.5,1.5,0,0,1,0-2.6l14.2-8.2a3.5,3.5,0,0,1,3.7,0l14.2,8.2a1.5,1.5,0,0,1,0,2.6l-14.3,8.2A4,4,0,0,1,162.1,66.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M164,67.9a4.6,4.6,0,0,1-2.3-.6l-14.1-8.1a2.1,2.1,0,0,1-1.1-1.9,2,2,0,0,1,1.1-1.8L162,47.2a4.2,4.2,0,0,1,4.3,0l14.1,8.1a2.1,2.1,0,0,1,1.1,1.9,2,2,0,0,1-1.1,1.8l-14.2,8.2A3.8,3.8,0,0,1,164,67.9Zm.2-20a5.3,5.3,0,0,0-1.6.4l-14.2,8.2a.8.8,0,0,0-.4.7.6.6,0,0,0,.4.6L162.5,66a2.7,2.7,0,0,0,3,0l14.3-8.2a.6.6,0,0,0,.4-.6.7.7,0,0,0-.4-.7l-14.1-8.2A3.7,3.7,0,0,0,164.2,47.9Z"
      transform="translate(-1 -0.4)"
    />
    <g id="barchart-2" class="barchartseed">
      <path
        class="cls-2"
        d="M156.2,138.1V90.8H156L141,92l-1.3-8.3h-.2l-13.8,7.9h-.2l-2.6-.8c-.1,0-.1,0-.1.2v47.1a1.6,1.6,0,0,0,.6,1.2l14,8.2a4.2,4.2,0,0,0,3.8,0l14.3-8.2A1.7,1.7,0,0,0,156.2,138.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M156.2,90.6l-15.1,1.3L139.4,97v50.9a3.4,3.4,0,0,0,2-.6l14.2-8.2a1.3,1.3,0,0,0,.8-1.1c-.2.1-.2-46.8-.2-47.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M139.3,148.6a4.6,4.6,0,0,1-2.3-.6l-14-8.2a2.1,2.1,0,0,1-1-1.6V91a1.2,1.2,0,0,1,.2-.7c.2-.1.6-.2.7-.1l2.4.6L139,82.9a1.1,1.1,0,0,1,.8,0l.3.2,1.3,8L156,89.8h.2c.4.1.5.4.5.8V138h0a2,2,0,0,1-1.1,1.7L141.4,148A3.5,3.5,0,0,1,139.3,148.6Zm-16-56.8v46.4a.7.7,0,0,0,.4.6l14,8.1a3.1,3.1,0,0,0,3.2,0l14.2-8.1a.8.8,0,0,0,.4-.7h0V91.4l-14.6,1.3h-.3l-.3-.2L139,84.6l-13.5,7.7h-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M139.3,148.6h-.8V96.9l2-5.9.5.2,15-1.3h.2a.7.7,0,0,1,.5.8v47.4a2,2,0,0,1-1.1,1.8l-14.2,8.2A4.3,4.3,0,0,1,139.3,148.6Zm.6-51.4v50a1.7,1.7,0,0,0,1.1-.4l14.2-8.2a.6.6,0,0,0,.4-.6V91.2l-14.1,1.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M124.8,92.8l.5-1.3-2.5-.7c-.2,0-.2,0-.2.2v47.1a1.7,1.7,0,0,0,.7,1.2l1.5.8V92.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M125.4,141.3l-2.4-1.5a2.1,2.1,0,0,1-1-1.6V91a1.2,1.2,0,0,1,.2-.7c.2-.1.6-.3.7-.1l3.2.9-.3.7c-.1.5-.4.9-.4,1.2Zm-2.1-49.7v46.5a.6.6,0,0,0,.4.5l.4.3V92.7h0l.3-.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M137.4,100.2l-14-8.2a1.5,1.5,0,0,1,0-2.6l14.3-8.2a3.5,3.5,0,0,1,3.7,0l14.1,8.2a1.5,1.5,0,0,1,0,2.6l-14.3,8.2A3.7,3.7,0,0,1,137.4,100.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M139.3,101.4a8.6,8.6,0,0,1-2.3-.5l-14.1-8.2a2.1,2.1,0,0,1-1.1-1.9,2.1,2.1,0,0,1,1.1-1.8l14.3-8.2a4.2,4.2,0,0,1,4.3,0L155.6,89a2.1,2.1,0,0,1,1.1,1.8,2.1,2.1,0,0,1-1.1,1.9l-14.2,8.2A5.9,5.9,0,0,1,139.3,101.4Zm.2-19.9a3.4,3.4,0,0,0-1.6.4l-14.2,8.2a.6.6,0,0,0-.4.6.7.7,0,0,0,.4.7l14.1,8.2a3.4,3.4,0,0,0,3.1,0l14.2-8.2a.8.8,0,0,0,.4-.7.6.6,0,0,0-.4-.6L141,81.9A2.4,2.4,0,0,0,139.5,81.5Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <g id="barchart-3" class="barchartseed">
      <path
        class="cls-3"
        d="M114.5,162.6a4.6,4.6,0,0,1-2.3-.6l-14.1-8.1a2.3,2.3,0,0,1-1.1-1.6V120.4a1.5,1.5,0,0,1,.3-.7.8.8,0,0,1,.7-.1l2.3.7,13.8-7.9a.6.6,0,0,1,.8,0h.2l1.3,8,14.7-1.3h.1c.4.1.5.4.5.8v32.1a2,2,0,0,1-1,1.7l-14,8.2A4.6,4.6,0,0,1,114.5,162.6Zm-16-41.5v31a.6.6,0,0,0,.4.5l14,8.2a3.4,3.4,0,0,0,3.1,0l14.3-8.2c.4-.3.4-.5.4-.7V120.7L116.2,122h-.3l-.3-.2-1.3-7.8-13.6,7.8h-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M131.4,151.9V120h-.2l-15,1.3-1.3-8.3h-.2l-13.8,7.9h-.2l-2.6-.8H98v31.8a1.4,1.4,0,0,0,.6,1.2l14,8.2a3.7,3.7,0,0,0,3.8,0l14.3-8.2A1.2,1.2,0,0,0,131.4,151.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M131.2,120l-15,1.3-1.7,5.2V162a4.1,4.1,0,0,0,1.9-.5l14.3-8.2a1.8,1.8,0,0,0,.8-1.2c-.1-.2-.1-31.4-.3-32.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M114.5,162.6h-.8V126.3l1.9-5.9.6.4,15-1.3h.2a.8.8,0,0,1,.5.8v32a2.1,2.1,0,0,1-1.1,1.8L116.7,162A4.6,4.6,0,0,1,114.5,162.6Zm.5-36v34.6a1.4,1.4,0,0,0,1-.4l14.3-8.2c.4-.3.4-.5.4-.7V120.7L116.6,122Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M100.6,155.2l-2.4-1.4a2.1,2.1,0,0,1-1-1.6V120.3a1.2,1.2,0,0,1,.2-.7c.2-.1.6-.3.7-.1l3.2.9-.3.7c-.1.5-.4.9-.4,1.2Zm-2.1-34.1v31a.6.6,0,0,0,.4.5l.4.3V122h0l.2-.7Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M112.6,129.5l-14.1-8.2a1.5,1.5,0,0,1,0-2.6l14.2-8.2a3.5,3.5,0,0,1,3.7,0l14.2,8.2a1.5,1.5,0,0,1,0,2.6l-14.3,8.2A3.5,3.5,0,0,1,112.6,129.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M114.5,130.7a8.6,8.6,0,0,1-2.3-.5L98.1,122a2.1,2.1,0,0,1-1.1-1.9,2,2,0,0,1,1.1-1.8l14.2-8.2a4.3,4.3,0,0,1,4.4,0l14.1,8.2a2,2,0,0,1,1.1,1.8,2.1,2.1,0,0,1-1.1,1.9l-14.2,8.2A4.1,4.1,0,0,1,114.5,130.7Zm.1-19.9a3.2,3.2,0,0,0-1.6.4l-14.2,8.1a.8.8,0,0,0-.4.7.7.7,0,0,0,.4.7l14.1,8.2a3.2,3.2,0,0,0,3,0l14.3-8.2a.8.8,0,0,0,.4-.7.7.7,0,0,0-.4-.7L116,111.2A2.3,2.3,0,0,0,114.6,110.8Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-3"
      d="M75,153.7a7.6,7.6,0,0,0,.5-1.4l-2.5-.6c-.1,0-.1,0-.1.1v14.4a1.6,1.6,0,0,0,.6,1.2l1.5.8V153.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M75.7,169.4l-2.4-1.5a2.3,2.3,0,0,1-1.1-1.6V151.8a1.1,1.1,0,0,1,.3-.6c.1-.2.5-.3.6-.2l3.2.9-.2.7a4.1,4.1,0,0,0-.4,1.2Zm-2.2-16.8v13.6a.9.9,0,0,0,.4.5l.4.3V153.5a1.4,1.4,0,0,0,.3-.6Z"
      transform="translate(-1 -0.4)"
    />
    <g id="barchart-4" class="barchartseed">
      <path
        class="cls-2"
        d="M106.4,166.1V151.6s0-.2-.1-.2l-15.1,1.3-1.3-8.3h-.1l-13.9,7.9h-.1l-2.7-.7H73v14.4a1.7,1.7,0,0,0,.7,1.2l14,8.1a3.7,3.7,0,0,0,3.8,0l14.2-8.1A1.6,1.6,0,0,0,106.4,166.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M106.3,151.6l-15.1,1.3L89.5,158v18.1a3.3,3.3,0,0,0,2-.5l14.2-8.2a1.5,1.5,0,0,0,.8-1.2c-.1-.1-.1-14-.2-14.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M89.5,176.8h-.8V157.9l2-6,.5.4,15.1-1.3h.1a.7.7,0,0,1,.5.8v14.5a2.2,2.2,0,0,1-1,1.8l-14.3,8.1A4.3,4.3,0,0,1,89.5,176.8Zm.5-18.6v17.1a1.7,1.7,0,0,0,1.1-.4l14.3-8.2a.7.7,0,0,0,.3-.6V152.2l-14.1,1.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M89.5,176.8a4.1,4.1,0,0,1-2.2-.7l-14-8.2a2.3,2.3,0,0,1-1.1-1.6V151.8a1.1,1.1,0,0,1,.3-.6c.1-.2.5-.3.6-.2l2.4.7,13.7-7.9a.6.6,0,0,1,.8,0h.3l1.3,8,14.7-1.3h.1a.7.7,0,0,1,.5.8v14.5a2.2,2.2,0,0,1-1,1.8l-14.3,8.1A2.5,2.5,0,0,1,89.5,176.8Zm-16-24.2v13.6a.9.9,0,0,0,.4.5l14,8.2a3.6,3.6,0,0,0,3.2,0l14.3-8.2a.7.7,0,0,0,.3-.6V152.2l-14.5,1.3h-.5l-1.3-7.8-13.5,7.6h-.4Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M87.7,161.1l-14.2-8.2a1.6,1.6,0,0,1,0-2.7l14.3-8.1a3.5,3.5,0,0,1,3.7,0l14.1,8.1a1.6,1.6,0,0,1,0,2.7l-14.2,8.2A4,4,0,0,1,87.7,161.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M89.5,162.2a4,4,0,0,1-2.2-.5l-14.2-8.2a2.1,2.1,0,0,1-1-1.8,2.3,2.3,0,0,1,1-1.9l14.3-8.1a4.3,4.3,0,0,1,4.4,0l14.1,8.1a2.3,2.3,0,0,1,1,1.9,2.1,2.1,0,0,1-1,1.8l-14.3,8.2A3.6,3.6,0,0,1,89.5,162.2Zm.1-19.9a2.8,2.8,0,0,0-1.5.4l-14.3,8.2c-.4.3-.4.5-.4.7a.6.6,0,0,0,.4.6l14.1,8.2a3.4,3.4,0,0,0,3.1,0l14.2-8.2c.4-.3.4-.5.4-.6s0-.6-.4-.7l-14.1-8.2A2.4,2.4,0,0,0,89.6,142.3Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <path
      class="cls-2"
      d="M207.2,124.5a.6.6,0,0,0-.1-.4l-11.5-6.5-1.3-.8c-4.7-2.2-11.3-1.1-18.5,3.9-10.9,7.8-19.8,23.1-20.7,36.4-.5,6.7.9,12,3.7,15.3l14.5,16.2,11.6,6.5h.2l.8-27.5c8.7-8.3,15.1-21,15.9-32.3l.6-.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M185.9,196.3c-.4,0-1-.1-1.2-.5l-14.8-16.7c-2.9-3.7-4.1-8.9-3.7-15.4,1.1-13.6,9.9-29,21.1-37,7.1-5,14.3-6.3,19.5-3.7s7.7,8.4,7.7,16.1c0,15.2-10.7,33.8-23.9,41.4-.3.1-.5.4-.9.5a27.1,27.1,0,0,0-.7,10.9,4.1,4.1,0,0,1-2.3,4.1Zm-14.7-17.7,14.5,16.2s.2.2.6,0a3.2,3.2,0,0,0,1.5-2.7,29.7,29.7,0,0,1,.8-11.8l.2-.2.2-.2a6,6,0,0,0,1.1-.6c12.8-7.4,23.2-25.5,23.2-40.3,0-7.2-2.5-12.5-7-14.9s-11.5-1.2-18.2,3.6c-10.8,7.6-19.5,22.7-20.5,35.9C167.1,170.2,168.3,175.3,171.2,178.6Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M158,171.2l14.8,8.3Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M155,158.9l14.8,8.4Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M181.1,117.4l14.8,8.3Z" transform="translate(-1 -0.4)" />
    <g id="money">
      <path
        class="cls-3"
        d="M185.1,195.9h-.4l-11.9-6.6L158,172.5c-2.8-3.5-4.1-8.9-3.6-15.4,1.1-13.6,9.9-29,21.2-37,7-4.8,13.8-6.3,19.1-3.8l1.5.8,11.4,6.5a.9.9,0,0,1,.4,1.2l-4.9,10.3-.3.5c-1,11.2-7.3,23.9-16,32.5l-.8,27.1a.7.7,0,0,1-.4.7Zm-11.2-7.7c.5.4,4.6,2.7,10.6,6l.8-26.8h.3c8.7-8.4,14.9-21,15.8-32h0l.6-.8,4.6-9.8-11.2-6.3-1.4-.8c-4.7-2.2-11.2-.8-17.6,3.7-10.9,7.7-19.6,22.7-20.5,35.9-.5,6.3.8,11.5,3.6,14.8h.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M197.3,150.2l.7-1.4a41.8,41.8,0,0,0,3.7-19.2c0-.5-.1-.9-.1-1.4l4.5-4.2c.1-.2.1-.4,0-.4l-10.6-6.1-.8-.5c-3.6-1.9-8-1.7-13.1.5s-11.6,7.9-15.9,14.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M197.6,151.3l-33.3-19.4.4-.7c4.7-6.6,10.5-11.7,16.3-14.4s9.9-2.5,13.7-.5l.9.5,10.6,6.1a1.3,1.3,0,0,1,.5.7,1.6,1.6,0,0,1-.3.8l-4.2,3.9c0,.4.2.7.2,1.1.5,5.9-.8,12.7-3.7,19.4Zm-31.3-19.8,30.8,17.8.4-.8c2.7-6.6,4.1-13,3.5-18.9,0-.5-.1-.9-.1-1.3v-.4l4.4-4.1L195.2,118l-.8-.5c-3.4-1.7-7.7-1.6-12.5.5A42.8,42.8,0,0,0,166.3,131.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M170.7,179c-2.8-3.3-4.2-8.6-3.7-15.3,1-13.3,9.8-28.6,20.7-36.4,14.3-10.1,26.3-4.1,26.3,11.8s-10.6,33.3-23.5,40.8a10.5,10.5,0,0,0-1.1.7,28.2,28.2,0,0,0-.8,11.5c.3,2-2.2,4.3-3.1,3.1Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M158.4,170.7l-.7,1.1,14.8,8.3.6-1.1Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M155.4,158.4l-.7,1.2,14.8,8.3.6-1.2Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M181.5,116.8l-.7,1.1,14.7,8.3.7-1.1Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-2"
        d="M198,152.5a8.6,8.6,0,0,1-1.6,4.9,15.7,15.7,0,0,1-4.3,4.2v3.2l-1.9,1v-3.2a14,14,0,0,1-5.7,2v-4.1a9.9,9.9,0,0,0,2.8-.4,11,11,0,0,0,2.9-1v-4.8l-.9.2a6.5,6.5,0,0,1-3.7-.4,3.3,3.3,0,0,1-1.1-2.9,9.1,9.1,0,0,1,1.6-4.7,18.6,18.6,0,0,1,4.2-4.2v-2.4l1.9-1v2.2a12.8,12.8,0,0,1,5.5-1.7l-1.3,4.4a9.7,9.7,0,0,0-4.2,1.3v4.6a9.3,9.3,0,0,1,3.7-.1,2,2,0,0,1,1.6.9A4.1,4.1,0,0,1,198,152.5Zm-9.5-3.9a1.2,1.2,0,0,0,.4,1h1.3v-3.6A4,4,0,0,0,188.5,148.6Zm5.4,6.4c0-.4-.1-.7-.4-.8h-1.3v3.8A3.8,3.8,0,0,0,193.9,155Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-2"
        d="M191.3,171.5c-9.3,5.3-16.7.9-16.7-9.7s7.6-23.4,16.7-28.9,16.6-.9,16.6,9.7S200.4,166.2,191.3,171.5Zm0-36.4c-8.2,4.7-14.9,16.3-14.9,25.8s6.7,13.4,14.9,8.6,14.9-16.4,14.9-25.9S199.5,130.3,191.3,135.1Z"
        transform="translate(-1 -0.4)"
      />
    </g>
    <g id="barchart-5" class="barchartseed">
      <path
        class="cls-2"
        d="M117.5,84.5H100.7a.4.4,0,0,0-.4.4V94a1.9,1.9,0,0,0,1.2,1.5l5,2.9a5.1,5.1,0,0,0,4.8.1l5.7-3.3a1.7,1.7,0,0,0,.8-1.3V84.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M109.3,99.6a5.7,5.7,0,0,1-2.9-.8l-5-2.9A3.7,3.7,0,0,1,99.9,94V84.9a.9.9,0,0,1,1-.9h16.7l.7.2a1.4,1.4,0,0,1,.2.7v9.6a1.5,1.5,0,0,1-1,1.2L111.8,99A6.1,6.1,0,0,1,109.3,99.6ZM100.9,85v9c0,.3.4.7.9,1.1l5,2.9c1.2.6,3.2.8,4.2.1l5.7-3.3a.8.8,0,0,0,.5-.8V85Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M117.5,84.5h-7.7V99a2.9,2.9,0,0,0,1.6-.4l5.7-3.3a1.7,1.7,0,0,0,.8-1.3V84.8C117.9,84.6,117.6,84.5,117.5,84.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M117,85.8l-5.7,3.3a5.4,5.4,0,0,1-4.8-.1l-5-2.9c-1.4-.8-1.6-2-.4-2.8l5.7-3.3a5.8,5.8,0,0,1,4.8.2l5,2.9C118,83.8,118.3,85.2,117,85.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M109.3,90.1a5.7,5.7,0,0,1-2.9-.8l-5-2.9c-.9-.6-1.5-1.2-1.5-2a1.8,1.8,0,0,1,1.1-1.6l5.7-3.3a5.9,5.9,0,0,1,5.2.1l5.1,2.9c.9.6,1.4,1.2,1.4,2a1.9,1.9,0,0,1-1,1.6l-5.7,3.3A4.4,4.4,0,0,1,109.3,90.1ZM108.9,80a5.3,5.3,0,0,0-1.8.4l-5.7,3.3a.8.8,0,0,0-.5.8c0,.4.4.8.9,1.1l5,2.9c1.2.6,3.2.8,4.2.1l5.7-3.3a.8.8,0,0,0,.5-.8c0-.4-.4-.8-.9-1l-5-3A7.2,7.2,0,0,0,108.9,80Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M116.3,87.8h-.8v6.7h.8Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M107.7,91.8h-.8v7h.8Z" transform="translate(-1 -0.4)" />
    </g>
    <g id="barchart-6" class="barchartseed">
      <path
        class="cls-2"
        d="M18.6,147.9H1.9a.4.4,0,0,0-.4.4v4.4q0,.9,1.2,1.5l5,2.9a4.9,4.9,0,0,0,4.7.1l5.7-3.3a1.7,1.7,0,0,0,.8-1.3v-4.5C19,148,18.8,147.9,18.6,147.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M10.3,158.3a5.7,5.7,0,0,1-2.9-.8l-5-2.9A2.8,2.8,0,0,1,1,152.7v-4.4c0-.6.3-1,.9-1H18.6c.3,0,.4.2.7.3a1.1,1.1,0,0,1,.3.7v5a2.5,2.5,0,0,1-1.1,1.2l-5.7,3.3A10.1,10.1,0,0,1,10.3,158.3ZM2,148.4v4.3c0,.3.4.7.9,1.1l5,2.9a4.7,4.7,0,0,0,4.3.1l5.6-3.3a.9.9,0,0,0,.6-.8v-4.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M18.6,147.9H11v9.9a5.3,5.3,0,0,0,1.6-.4l5.6-3.3a1.5,1.5,0,0,0,.8-1.4v-4.4A.4.4,0,0,0,18.6,147.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M18.1,149.2l-5.7,3.3a5.6,5.6,0,0,1-4.7-.2l-5-2.9c-1.5-.8-1.6-1.9-.4-2.7l5.6-3.3a5.4,5.4,0,0,1,4.8.1l5,2.9C19.2,147.2,19.4,148.4,18.1,149.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M10.3,153.4a5.7,5.7,0,0,1-2.9-.8l-5-2.9a2.3,2.3,0,0,1-1.4-2,1.8,1.8,0,0,1,1-1.6l5.7-3.3a6.6,6.6,0,0,1,5.3.2l5,2.9a2.3,2.3,0,0,1,1.4,2,1.9,1.9,0,0,1-1,1.5l-5.7,3.3A3.4,3.4,0,0,1,10.3,153.4Zm-.2-10a3.8,3.8,0,0,0-1.9.4l-5.7,3.3a1,1,0,0,0-.5.8c0,.4.4.7.9,1l5,2.9a4.7,4.7,0,0,0,4.3.1l5.6-3.3a.7.7,0,0,0,.6-.7c0-.4-.4-.8-.9-1.1l-5.1-2.9A3.9,3.9,0,0,0,10.1,143.4Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M17.5,151.2h-.8v1.9h.8Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M8.9,153.9H8.1v3.5h.8Z" transform="translate(-1 -0.4)" />
    </g>
    <g id="barchart-7" class="barchartseed">
      <path
        class="cls-2"
        d="M25,72.2H8.2c-.1,0-.4.2-.4.4v4.5A1.9,1.9,0,0,0,9,78.6l5,2.9a5.1,5.1,0,0,0,4.8.1l5.6-3.3a1.5,1.5,0,0,0,.8-1.3V72.5C25.2,72.4,25.1,72.2,25,72.2Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M16.7,82.7a5.2,5.2,0,0,1-2.9-.8L8.7,79a3.1,3.1,0,0,1-1.4-1.9V72.6a.9.9,0,0,1,.9-.9H25a.9.9,0,0,1,.6.3.7.7,0,0,1,.3.6v5a1.5,1.5,0,0,1-1.1,1.2l-5.6,3.3A5.4,5.4,0,0,1,16.7,82.7ZM8.3,72.8v4.3c0,.3.4.7,1,1.1l5,2.9c1.2.6,3.2.8,4.2.1l5.7-3.3a1,1,0,0,0,.5-.8V72.8Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M25,72.2H17.3v9.9a3.2,3.2,0,0,0,1.6-.4l5.7-3.3a1.7,1.7,0,0,0,.8-1.3V72.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M24.4,73.6l-5.6,3.3a5.8,5.8,0,0,1-4.8-.2L9,73.8c-1.4-.8-1.6-2-.4-2.8l5.7-3.3a5.6,5.6,0,0,1,4.7.2l5,2.9C25.5,71.7,25.6,72.9,24.4,73.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M16.7,77.9a5.2,5.2,0,0,1-2.9-.8L8.7,74.2a2.3,2.3,0,0,1-1.4-2,2,2,0,0,1,1-1.6L14,67.3a6.6,6.6,0,0,1,5.3.2l5,2.9a2.5,2.5,0,0,1,1.5,2,1.7,1.7,0,0,1-1.1,1.5L19,77.2A4.2,4.2,0,0,1,16.7,77.9Zm-.3-10.2a5.8,5.8,0,0,0-1.9.4L8.9,71.4c-.3.2-.6.4-.6.8s.4.8,1,1.1l5,2.9a4.5,4.5,0,0,0,4.2.1L24.2,73a1,1,0,0,0,.5-.8c0-.4-.4-.8-.9-1l-5-2.9A6.5,6.5,0,0,0,16.4,67.7Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M23.7,75.5h-.8v2h.8Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M15.2,78.4h-.8v3.5h.8Z" transform="translate(-1 -0.4)" />
    </g>
    <g id="barchart-8" class="barchartseed">
      <path
        class="cls-2"
        d="M244.2,315.3H227.4c-.1,0-.4.2-.4.4v4.5q0,.9,1.2,1.5l5,2.9a5.1,5.1,0,0,0,4.8.1l5.7-3.3a1.7,1.7,0,0,0,.8-1.3v-4.5C244.6,315.5,244.5,315.3,244.2,315.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M236,325.8a5.7,5.7,0,0,1-2.9-.8l-5-2.9a3.7,3.7,0,0,1-1.5-1.9v-4.5a.9.9,0,0,1,1-.9h16.7a.9.9,0,0,1,1,.9v5.1a2,2,0,0,1-1.1,1.1l-5.7,3.3A7.6,7.6,0,0,1,236,325.8Zm-8.3-9.9v4.3c0,.3.4.7.9,1.1l5,2.9a5,5,0,0,0,4.3.1l5.6-3.3a.9.9,0,0,0,.6-.8v-4.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M244.2,315.3h-7.7v9.9a2.9,2.9,0,0,0,1.6-.4l5.7-3.3a1.4,1.4,0,0,0,.8-1.3v-4.5A.4.4,0,0,0,244.2,315.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M243.8,316.5l-5.7,3.3a5.2,5.2,0,0,1-4.7-.1l-5-2.9c-1.5-.8-1.6-2-.4-2.8l5.6-3.3a5.8,5.8,0,0,1,4.8.2l5,2.9C244.9,314.7,245,315.9,243.8,316.5Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M236,320.9a5.7,5.7,0,0,1-2.9-.8l-5-2.9a2.5,2.5,0,0,1-1.5-2,1.9,1.9,0,0,1,1.1-1.6l5.7-3.3c1.3-.8,3.7-.6,5.3.2l5,2.9a2.3,2.3,0,0,1,1.4,1.9,1.9,1.9,0,0,1-1,1.6l-5.7,3.3A3.6,3.6,0,0,1,236,320.9Zm-.2-10a3.8,3.8,0,0,0-1.9.4l-5.7,3.3a.8.8,0,0,0-.5.7c0,.4.4.8.9,1.1l5,2.9a4.7,4.7,0,0,0,4.3.1l5.6-3.3a.9.9,0,0,0,.6-.8c0-.4-.4-.7-1-1l-5-2.9A4.6,4.6,0,0,0,235.8,310.9Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-2" d="M243,318.6h-.8v2h.8Z" transform="translate(-1 -0.4)" />
    </g>
    <path class="cls-3" d="M234.6,321.4h-.8v3.4h.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M121.1,162.5H104.3a.4.4,0,0,0-.4.4v4.5c0,.5.4,1,1.2,1.4l5,2.9c1.5.8,3.6,1,4.8.2l5.6-3.3a1.5,1.5,0,0,0,.8-1.3v-4.5C121.3,162.6,121.2,162.5,121.1,162.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M112.7,172.9a4.9,4.9,0,0,1-2.9-.8l-5-2.9a2.7,2.7,0,0,1-1.4-1.8v-4.5a.9.9,0,0,1,.9-.9h16.8l.6.2a1.5,1.5,0,0,1,.3.7v5a2.1,2.1,0,0,1-1.1,1.2l-5.7,3.3A6.2,6.2,0,0,1,112.7,172.9Zm-8.3-9.9v4.4c0,.3.4.7,1,1l5,3a5.1,5.1,0,0,0,4.2.1l5.7-3.3a1,1,0,0,0,.5-.8V163Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M121.1,162.5h-7.7v9.9a3.2,3.2,0,0,0,1.6-.4l5.5-3.4a1.5,1.5,0,0,0,.8-1.3v-4.5C121.3,162.6,121.2,162.5,121.1,162.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M120.5,163.8l-5.6,3.3a5.4,5.4,0,0,1-4.8-.1l-5-2.9c-1.5-.8-1.6-2-.4-2.8l5.7-3.3a5.6,5.6,0,0,1,4.7.2l5,2.9C121.6,161.8,121.7,163,120.5,163.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M112.7,168.1a5.7,5.7,0,0,1-2.9-.8l-5-2.9c-.9-.6-1.4-1.2-1.4-2a1.9,1.9,0,0,1,1-1.6l5.7-3.3a6.2,6.2,0,0,1,5.3.1l5.1,3.1c1,.5,1.5,1.1,1.5,1.9a1.8,1.8,0,0,1-1.1,1.6l-5.7,3.3A4.9,4.9,0,0,1,112.7,168.1Zm-.2-10.1a5.8,5.8,0,0,0-1.9.4l-5.6,3.3a.9.9,0,0,0-.6.8c0,.4.4.8,1,1.1l5,2.9a4.8,4.8,0,0,0,4.2.1l5.7-3.3a1,1,0,0,0,.5-.8c0-.4-.4-.8-.9-1l-5-3A6,6,0,0,0,112.5,158Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M119.9,165.8h-.8v2h.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M111.3,168.6h-.8V172h.8Z" transform="translate(-1 -0.4)" />
    <g id="heavybit">
      <path
        class="cls-4"
        d="M248.9,127.1l11.9-7.7v-.3l-15.2-18h-.3L243,112l-.6,7.7v.3l6.5,7.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M248.6,128.6a2.3,2.3,0,0,1-1.2-.6l-6.5-7.7v-.6l.6-7.7,2.7-12.1.9-.3c.5,0,1.1,0,1.4.6L262,118.8v.6c0,.3-.3.9-.6.9L249.5,128C249.2,128.6,248.9,128.6,248.6,128.6Zm-5-9.2,5.3,6.3,10.1-6.6-12.8-15.7-2,8.9Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-4"
        d="M293.7,72.3,237,39.7a4,4,0,0,0-3.5-.6l-11,6.5c-.3,0-.3.3,0,.6l13.4,13.9V83.6c0,3.5,2.6,8.3,5.9,10l8.3,4.8c.3.3.3.6.6.9a30,30,0,0,0,13,19.5c.3.3.6,0,.3-.6-1.5-2.6-3.8-8.3-3.2-12.7a1.1,1.1,0,0,1,.9-.3l17.5,10.1v.3l7.4,19.3a.3.3,0,0,0,.3.3l10.9-6.6a4,4,0,0,0,1.5-3.5v-43A12.3,12.3,0,0,0,293.7,72.3Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M287.2,136.3l-.9-.3c-.3-.3-.9-.6-.9-.8l-7.1-19L262,106.7c-.3,3.8,2,8.9,3.2,10.7s.3,1.7-.3,2a1.4,1.4,0,0,1-2.1,0,32.4,32.4,0,0,1-13.6-20.1l-.3-.3-8.3-4.8c-3.6-2-6.5-7.1-6.5-11.2V60.4L221,46.8c-.3-.3-.6-.9-.3-1.2s.3-.9.9-1.2l11-6.5a4.9,4.9,0,0,1,5,.6l56.7,32.6a14.6,14.6,0,0,1,6.5,11.3v42.7a5.5,5.5,0,0,1-2.1,4.7Zm-25.5-32.6L280,114.4l.3.6,6.9,18.4,9.7-6c.6-.3.9-1.1.9-2.3v-43c0-3.3-2.3-7.4-5-8.9L236.2,40.6a4.5,4.5,0,0,0-2.7-.6l-9.8,5.9,13,13.6V83.3c0,3.2,2.4,7.4,5.1,8.9l8.9,5.3.9,1.5a30.8,30.8,0,0,0,9.5,16.6c-1.2-3-2.4-6.8-1.8-10.1v-.6Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M282.4,79.1,225.8,46.2c-3-1.8-5.7-.3-5.7,3.3V92.2a12.7,12.7,0,0,0,5.7,9.7l8.6,5.1c.3,0,.3.3.3.6a30.5,30.5,0,0,0,13,19.8c.3.3.6,0,.3-.6-1.5-2.6-4.1-8.6-2.9-13,0-.3.2-.3.5-.3l36.5,21.1c3,1.7,5.7.3,5.7-3.3V88.9A10.8,10.8,0,0,0,282.4,79.1Z"
        transform="translate(-1 -0.4)"
      />
      <path
        class="cls-3"
        d="M285.1,136.9a7.8,7.8,0,0,1-3.3-.9l-35.3-20.4c-.3,3.8,2.1,8.9,3.3,10.7s.3,1.7-.3,2a1.4,1.4,0,0,1-2.1,0,31.4,31.4,0,0,1-13.6-20.1l-8.6-5.1A13.4,13.4,0,0,1,219,92.4V49.5a5.4,5.4,0,0,1,2.3-4.8c1.5-.9,3.3-.6,5.4.3l56.6,32.6a13.5,13.5,0,0,1,6.2,11v42.7a5.3,5.3,0,0,1-2.3,4.7A3.2,3.2,0,0,1,285.1,136.9Zm-39.5-24.6a1.1,1.1,0,0,1,.9.3L283,133.7c1.2.6,2.1.9,2.7.3s.9-1.2.9-2.7V88.9a10.9,10.9,0,0,0-5.1-8.6L224.9,47.7c-1.2-.6-2.1-.9-2.7-.3s-.9,1.2-.9,2.6V92.7a10.7,10.7,0,0,0,5.1,8.6l8.6,5.1a3,3,0,0,1,1.2,1.5,30.7,30.7,0,0,0,9.4,16.6c-1.1-3.3-2.3-7.1-1.4-10.7l.3-.6.8-.6A.3.3,0,0,1,245.6,112.3Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-3" d="M294.2,72.5l-9.9,6,1.4,2.3,9.9-6.1Z" transform="translate(-1 -0.4)" />
      <path class="cls-3" d="M241.4,42.2l-9.8,6,1.4,2.3,9.8-6Z" transform="translate(-1 -0.4)" />
      <path
        class="cls-3"
        d="M298.3,83.4l-10.8,6.8,1.4,2.2,10.8-6.8Z"
        transform="translate(-1 -0.4)"
      />
      <path class="cls-4" d="M298,93l-8.5,5.5v34.8l8.5-4.8.3-2.5Z" transform="translate(-1 -0.4)" />
      <g class="hblogo cls-6">
        <g>
          <path
            class="cls-4"
            d="M255.2,79.1l2.6,1.5h0c.3.1.5.4.7.8,1.7,4.6,3.6,9.3,5.4,14a.6.6,0,0,1,0,.6l-5.6,7.8c-.1.2-.3.2-.5.1l-5.6-3.2-5.5-3.2c-.3-.1-.4-.3-.5-.6-1.8-4.7-3.7-9.4-5.5-14.2a.4.4,0,0,1,0-.6l5.6-7.8h.5l2.7,1.6,2.8,1.6ZM242.7,63.6c-.3-.1-.5-.1-.6.1l-9.7,13.5c-.2.2-.2.4,0,.7l9.6,24.7a1.2,1.2,0,0,0,.6.8l5.2,2.9,4.5,2.6,4.8,2.8,4.9,2.7c.2.2.4.2.5,0l9.8-13.6a.8.8,0,0,0,0-.7l-9.7-24.7a1.8,1.8,0,0,0-.5-.7l-9.2-5.2Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M257.6,92.7c-.1-.2-.3-.1-.4,0l-.6,1-3.8,5.2c-.2.2-.2.3.1.5h.1l.9.5,1.1.7,1.2.7,1,.5h0c.2.1.3.2.4,0l4.5-6.2c.1-.2,0-.3-.2-.5l-2.1-1.2-2.2-1.2Z"
            transform="translate(-1 -0.4)"
          />
          <path
            class="cls-2"
            d="M257.3,82,255,80.6l-2.2-1.3v.2l4.5,11.6c.1.2.2.4.3.4l2.2,1.3,2.1,1.2c.3.2.3.1.2-.3l-4.5-11.3C257.6,82.2,257.5,82,257.3,82Z"
            transform="translate(-1 -0.4)"
          />
        </g>
      </g>
    </g>
    <path
      class="cls-3"
      d="M73.8,178.5a5.1,5.1,0,0,1,.5,3.7,6.2,6.2,0,0,1-2.7.9l-6.8.3a5.7,5.7,0,0,1-1.8-.3,2.5,2.5,0,0,1-1.3-1.4,1.1,1.1,0,0,1,.6-1.4l7.2-3.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M82.1,186.4l.2,5.1a5.5,5.5,0,0,1-.7,2.8l-.2.4a4,4,0,0,1-2.8,1.9l-1.2.2a1.3,1.3,0,0,1-1.2-.3,1.6,1.6,0,0,1-.6-1.8l1.2-3.7a13,13,0,0,0,.8-3.4l.3-2.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M75.3,161.5s-1.1,9.6-1.6,17a.8.8,0,0,1-.5.7,4.7,4.7,0,0,1-4.8-.4,1.4,1.4,0,0,1-.6-1.2,182.7,182.7,0,0,0-.4-20.1c-.8-7.8,3.8-7.4,3.8-7.4l5.4,6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M68.3,179.2a1.8,1.8,0,0,1-.8-1.5,181.8,181.8,0,0,0-.4-20.1c-.3-3.1.2-5.4,1.4-6.7a3.8,3.8,0,0,1,2.8-1.1h.1l5.7,6.3-1.3,5.5c-.1.5-1.1,9.9-1.6,17a1.2,1.2,0,0,1-.7,1,5.1,5.1,0,0,1-2.2.5A5.4,5.4,0,0,1,68.3,179.2Zm2.8-28.6a3,3,0,0,0-2,.9c-1.1,1.1-1.5,3.2-1.2,6.1a183.5,183.5,0,0,1,.4,20.2.9.9,0,0,0,.5.8,4.4,4.4,0,0,0,4.4.3c.2-.1.2-.2.3-.4.5-7.3,1.6-16.9,1.6-17l1.3-5.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M82.1,164.4a60.4,60.4,0,0,1,.6,12.9,54.9,54.9,0,0,0,0,9.4.7.7,0,0,1-.7.9,6.4,6.4,0,0,1-3.7-.5,2.6,2.6,0,0,1-1.5-2.5c.1-3.4-1.4-14-4-22.8-3.2-10.6,6.7.3,6.7.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M78.1,187.6a2.8,2.8,0,0,1-1.7-2.8c.1-3.3-1.5-14.1-4-22.6-.9-2.9-.9-4.5,0-5s6.4,3.9,7.3,4.9l2.8,2.3h0a62.3,62.3,0,0,1,.6,13,54.2,54.2,0,0,0,0,9.3,1.1,1.1,0,0,1-1.1,1.3H80.8A9.4,9.4,0,0,1,78.1,187.6Zm1-25.1c-2.4-2.7-5.5-5.2-6.4-4.8s-.7.7.3,4.1c2.6,8.8,4.2,19.4,4.1,22.9a2.3,2.3,0,0,0,1.3,2.1,6.4,6.4,0,0,0,3.5.4c.3,0,.4-.2.4-.5a47.1,47.1,0,0,1,0-9.5,53.8,53.8,0,0,0-.6-12.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M73.7,113a6,6,0,0,0-5.8,0c-2.2,1.2-2.4,14.4-2.4,14.4s.8,3.9-.5,13.3.8,21.3.8,21.3,3.6-3.9,4.2-16.4,2.2-29.5,2.2-29.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M65.5,162.1c0-.1-2.2-12-.8-21.4s.6-13.2.5-13.2c0-2.3.3-13.5,2.6-14.7a6.5,6.5,0,0,1,6.2,0l.3.2-1.5,3.4c-.1,1.1-1.6,17.4-2.2,29.4s-4.2,16.5-4.3,16.7l-.5.6Zm2.6-48.7c-1.4.8-2.1,9-2.2,14,.1.5.7,4.4-.6,13.4s.2,17.3.7,20.2c1-1.6,3.2-6.1,3.6-15.5.6-12.4,2.2-29.3,2.2-29.5l1.3-2.9A5.9,5.9,0,0,0,68.1,113.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M68.5,122.4v-5.9a2.1,2.1,0,0,0-1.1-1.8l-6.1-3.5a.6.6,0,0,0-.9.5v14.2a2.2,2.2,0,0,0,1,1.8l6.2,3.6a.6.6,0,0,0,.9-.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M67.4,131.6,61.2,128a2.4,2.4,0,0,1-1.2-2.1V111.7a.9.9,0,0,1,.5-.8.9.9,0,0,1,1,0l6.2,3.5a2.4,2.4,0,0,1,1.3,2.1v14.2a.9.9,0,0,1-.5.8H67.4Zm-6.5-20.1a.3.3,0,0,0-.1.2v14.2a1.6,1.6,0,0,0,.9,1.5l6.2,3.6h.2V116.6a1.6,1.6,0,0,0-.9-1.5l-6.1-3.5h-.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M67,123v-5.9a2.1,2.1,0,0,0-1.1-1.8l-6.1-3.5a.6.6,0,0,0-.9.5v14.2a2.2,2.2,0,0,0,1,1.8l6.2,3.6a.6.6,0,0,0,.9-.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M65.9,132.2l-6.2-3.6a2.4,2.4,0,0,1-1.2-2.1V112.3a.9.9,0,0,1,.5-.8.9.9,0,0,1,1,0l6.1,3.5a2.4,2.4,0,0,1,1.3,2.1v14.2a.9.9,0,0,1-.5.8h-.5A.5.5,0,0,1,65.9,132.2Zm-6.5-20.1v14.4a1.6,1.6,0,0,0,.9,1.5l6.2,3.6h.2V117.2a1.6,1.6,0,0,0-.9-1.5l-6.1-3.5h-.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M82.3,132.9s.6,24.9,2.4,34.1c0,0-10.3,2.9-13.6-8.7s-1.4-24.6-1.4-24.6l1.4-7.1,6.8-13.2,5.2,3.3,2,1.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M70.7,158.5c-3.3-11.5-1.4-24.6-1.4-24.8l1.4-7.1,7-13.7,5.6,3.5,2.2,1.9-2.9,14.6c0,1.2.7,25.1,2.4,34v.3h-.3a12.8,12.8,0,0,1-2.8.3C78.6,167.7,73,166.4,70.7,158.5Zm11.2-25.6,2.8-14.3L82.9,117,78,113.9l-6.6,12.8-1.4,7c0,.1-1.9,13.1,1.4,24.4s11,8.9,12.8,8.5C82.5,157.4,81.9,133.2,81.9,132.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M80.2,111.5s-.9.8-.3,3l.3,1.2s-2.9,5.1-7.8,5.3c0,0,1.7-4.5,1-6.8s4.1-2.6,4.1-2.6h2.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M72,120.8s1.6-4.4,1-6.6a1.9,1.9,0,0,1,.2-1.5c1-1.4,4-1.6,4.2-1.6h3.7l-.7.7s-.7.7-.2,2.6l.3,1.4h-.1c-.1.2-3.1,5.3-8.1,5.5h-.6Zm7.5-6.2a4.7,4.7,0,0,1,0-2.7h-2c-.8.1-3,.4-3.6,1.3a.9.9,0,0,0-.1.9c.5,1.9-.4,5.2-.8,6.5,3.9-.5,6.4-4.2,6.9-4.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M74.1,119s-.7-1.3-.3-4.5H71.7a8.7,8.7,0,0,0-.2,5.1c.8,3-.4,7-.4,7A73,73,0,0,1,74.1,119Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M70.7,126.5s1.1-3.9.4-6.8a8.7,8.7,0,0,1,.2-5.3v-.2h2.8v.4a8.8,8.8,0,0,0,.2,4.3v.4a65.7,65.7,0,0,0-3,7.6Zm2.7-11.6H72a9,9,0,0,0-.1,4.6,10.8,10.8,0,0,1,.2,3.1,27.1,27.1,0,0,1,1.6-3.7A9.6,9.6,0,0,1,73.4,114.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M79.6,114.3s.6,3.2-5.5,4.7a23.3,23.3,0,0,0-3,7.7h.2a13,13,0,0,1,4.2-5l.5-.6.4-1.2c0-.1.2-.2.3-.2l1.3.5h.6c.8-.3,3-1.4,3.4-3.2s-.5-3.6-2.2-3.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M71,127.1c-.2-.1-.4-.3-.3-.5a23.4,23.4,0,0,1,3.1-7.8H74c5.6-1.4,5.2-4.1,5.2-4.2v-1.7h.4a3,3,0,0,1,2.1,1.3,4,4,0,0,1,.5,3.1c-.4,1.9-2.6,3.1-3.6,3.5a1.1,1.1,0,0,1-.8,0l-1.2-.4-.4,1.1a1.6,1.6,0,0,1-.6.8,12,12,0,0,0-4,4.9c-.1.2-.2.3-.4.3S71.1,127.1,71,127.1Zm5.8-7.8,1.3.5h.3c.7-.3,2.8-1.3,3.1-2.9a3.4,3.4,0,0,0-.3-2.5,2,2,0,0,0-1.2-.8v.8c.1.5.2,3.5-5.6,5a26.1,26.1,0,0,0-2.4,5.5,11.7,11.7,0,0,1,3.3-3.4,1,1,0,0,0,.4-.5l.4-1.2.3-.4h.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M79.2,112.2c-.4,1.1-1.8,3-6.7,2.9a1,1,0,0,1-.9-.7,14.7,14.7,0,0,1,.2-9.1l.3-1.4,7.4,1.5.5,3.3s1.7-.2,1.2,1.6-.7,1.1-1.1,1.1A1.8,1.8,0,0,0,79.2,112.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M72.6,115.5a1.4,1.4,0,0,1-1.3-1,15,15,0,0,1,.2-9.2l.4-1.7,8,1.6.5,3.3a1.2,1.2,0,0,1,1,.5,1.7,1.7,0,0,1,.2,1.6,1.7,1.7,0,0,1-1.4,1.4.7.7,0,0,0-.6.4c-.5,1.2-2,3.2-6.9,3.2Zm6.3-3.5a1.6,1.6,0,0,1,1.2-.9c.1,0,.5-.1.8-.8a1.4,1.4,0,0,0,0-.9,1.1,1.1,0,0,0-.7-.2h-.4l-.6-3.4-6.7-1.4-.2,1.1a14.5,14.5,0,0,0-.2,8.8.7.7,0,0,0,.6.4C77.1,114.8,78.5,113,78.9,112Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M80.8,106a2.9,2.9,0,0,0,1.5-1.6,2.8,2.8,0,0,0-.5-3,3.1,3.1,0,0,0-1.7-1c-2.1-.5-3.9,1.8-6.1.7s0-2.5,1-1.6a2.3,2.3,0,0,0-3.4-.3,3.6,3.6,0,0,0,2.5,6.2,13,13,0,0,1,3.9.8,3.1,3.1,0,0,0,2.3,0Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M82.7,108.9a4.5,4.5,0,0,0,.6-3.5c-.4-1.3-2.7-.6-3.9-.1a.9.9,0,0,0-.5,1.1l.7,2.1a1,1,0,0,0,.9.7H82Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M70.1,124s.2-2.5-1-3.4l-.6-.3v2.1a.4.4,0,0,1-.7.4,7.8,7.8,0,0,1-2.4-2.4c-.7-1.5-1.7-.2-1.4,1.8s4,3.8,4,3.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M67.7,126.3c-.2-.1-3.9-1.8-4.2-4.1s.2-2.7.9-2.9.8-.1,1.2.8a7.2,7.2,0,0,0,2.3,2.3.1.1,0,0,0,.1-.1v-2.7l1.1.5h.1c1.4,1.1,1.2,3.7,1.2,3.8h0l-2.5,2.2Zm1.2-5.3v1.5a.8.8,0,0,1-.5.7,1,1,0,0,1-.9-.1,7.8,7.8,0,0,1-2.5-2.6l-.3-.4c-.1,0-.5.7-.4,2.1s2.4,2.8,3.5,3.4l1.9-1.7C69.7,123.4,69.7,121.7,68.9,121Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M83.1,116.7l2,1.7a3.1,3.1,0,0,1,.9,1.8c.2,2.7.3,9.9-3.7,15.3a2.7,2.7,0,0,1-1.9,1.1,4,4,0,0,1-3.1-1.1c-1.8-1.7-5.1-4.8-8-7.8a.7.7,0,0,1,0-1l1.8-1.9a.6.6,0,0,1,.9-.1l6.9,6.1a43.3,43.3,0,0,1,2.4-10.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M80,137h.4a3,3,0,0,0,2.2-1.2c4-5.5,4-12.7,3.8-15.6a3,3,0,0,0-1-2l-2-1.7-.5.6,2,1.7a2.1,2.1,0,0,1,.7,1.5c.2,2.8.3,9.8-3.6,15.1a2.2,2.2,0,0,1-1.6.9,3.6,3.6,0,0,1-2.8-1c-1.7-1.6-5.1-4.8-8-7.8a.3.3,0,0,1,0-.4l1.8-1.9a.3.3,0,0,1,.4,0l7.5,6.6V131a42.1,42.1,0,0,1,2.4-10.2l-.7-.3a43.4,43.4,0,0,0-2.4,9.7l-6.4-5.6a1.2,1.2,0,0,0-1.5.1L69,126.6a1.1,1.1,0,0,0,0,1.5l8,7.8A4.6,4.6,0,0,0,80,137Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M68.1,126.4l.9.7,2.1-2.2-.9-.7a.4.4,0,0,0-.5,0L68,125.9C67.8,126,67.9,126.2,68.1,126.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M67.8,126.7a.6.6,0,0,1-.3-.6,1.4,1.4,0,0,1,.2-.6l1.7-1.7a.7.7,0,0,1,1,0l1.2,1-2.7,2.8Zm2.2-2.3-1.7,1.7-.2.3.2-.3.6.5,1.6-1.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M78.1,125.8v.6c-.1.2-.3.4-.6.2l-1.6-1a.9.9,0,0,1-.4-.8v-.6c0-.3.3-.4.6-.2l1.6,1A.7.7,0,0,1,78.1,125.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M77.2,127l-1.6-1a1.2,1.2,0,0,1-.6-1.2v-.6c0-.2.2-.4.4-.6h.7l1.6,1a1.2,1.2,0,0,1,.6,1.3v.6a1,1,0,0,1-.4.5h-.7Zm.5-1.3c0-.2,0-.4-.2-.5l-1.6-1v.6a.8.8,0,0,0,.2.5l1.6,1Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M79.8,109.9l-1,.3.3.8.9-.3Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M75,146.7H73.8a1.6,1.6,0,0,1-1.5-1.7v-3.8a1.1,1.1,0,0,1,.3-.8,1.1,1.1,0,0,1,.7-.3l3.3.3a1,1,0,0,1,.7.4,1.1,1.1,0,0,1,.2.8l-.7,3.7a1.7,1.7,0,0,1-1.7,1.4Zm-1.9-5.9c-.1,0-.1.1-.1.2v3.8a.9.9,0,0,0,.8.9H75a.9.9,0,0,0,1-.8l.7-3.7v-.2h-.1l-3.3-.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-3" d="M75.8,136.7l-.5,3.9h.8l.5-3.9Z" transform="translate(-1 -0.4)" />
    <path class="cls-3" d="M74.5,138h-.8v2.4h.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M77.1,189.6l-.2.8,3.1.7v-.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M76.5,191.1l-.2.8,3,.7.2-.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M66.3,177.8l-.7.5,1.3,1.5.6-.5Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M65,178.8l-.7.5,1.2,1.5.7-.5Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M75.3,108.5c-.2.6-.1,1.1.3,1.2s.7-.3.9-.8.1-1.1-.3-1.2S75.5,107.9,75.3,108.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M71.4,107.3c-.1.6.1,1.1.5,1.1s.7-.4.8-1-.1-1.1-.5-1.1S71.5,106.8,71.4,107.3Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M68,115.2l-1.4.8.4.7,1.4-.8Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M61,112.8l1.4-.8-.3-.6-1.4.7Z" transform="translate(-1 -0.4)" />
    <path class="cls-2" d="M67.3,130.6l1.4-.8-.4-.7-1.4.8Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-4"
      d="M104.5,151.7s3.4-.6,4.1,2.4a75,75,0,0,1,1.8,15.5,54.3,54.3,0,0,0,1.4,9.8L101.3,178,99,170.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M101,178.4l-2.4-8,5.6-19.1h.2c1.3-.2,3.9,0,4.6,2.7a79.7,79.7,0,0,1,1.8,15.6,55.9,55.9,0,0,0,1.4,9.7v.5Zm3.8-26.4-5.4,18.4,2.2,7.3,9.7,1.3a55.9,55.9,0,0,1-1.3-9.3,71.4,71.4,0,0,0-1.8-15.4,3,3,0,0,0-3.1-2.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M125.2,224.8a7.5,7.5,0,0,0-2.4-4.1,41.5,41.5,0,0,1-4.8-5.9l-.8-.8-.7.2a54.6,54.6,0,0,1,0,7.2l1.6.9.2-.6a11.4,11.4,0,0,0,3.9,2.8C124.2,225.3,125.2,224.8,125.2,224.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M122.1,224.9a10.3,10.3,0,0,1-3.6-2.5l-.2.5-2.2-1.3v-.3a53,53,0,0,0,0-7.1v-.3l1.2-.4,1,1.1a37.3,37.3,0,0,0,4.8,5.8,7.6,7.6,0,0,1,2.5,4.4v.3h-.3a2.9,2.9,0,0,1-1.2.2Zm.5-4a36.4,36.4,0,0,1-4.8-5.9l-.6-.7H117a37.1,37.1,0,0,1,0,6.7l1,.6.3-.8.4.5a10.9,10.9,0,0,0,3.8,2.7,4.7,4.7,0,0,0,2.4.3A9.9,9.9,0,0,0,122.6,220.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M120.6,214.4s.3,3.9,2.2,6.2c0,0-.8,1.7-3.1,0s-2.5-7.3-2.5-7.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M119.5,220.9c-2.4-1.8-2.6-7.4-2.6-7.6v-.6l4.1,1.4v.2s.4,3.8,2.1,6l.2.2v.2a2.1,2.1,0,0,1-1.2.9h-.5A2.6,2.6,0,0,1,119.5,220.9Zm.7-6.2-2.6-.9c.1,1.4.6,5.2,2.3,6.5a2.2,2.2,0,0,0,1.9.6l.6-.3A12.7,12.7,0,0,1,120.2,214.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M120.8,226.6a7.5,7.5,0,0,0-2.4-4.1,41.5,41.5,0,0,1-4.8-5.9l-.8-.8-.7.2a54.6,54.6,0,0,1,0,7.2l1.6.9.2-.6a11.4,11.4,0,0,0,3.9,2.8C119.8,227.1,120.8,226.6,120.8,226.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M117.8,226.8a10.3,10.3,0,0,1-3.6-2.5l-.2.5-2.3-1.3v-.3a53,53,0,0,0,0-7.1v-.3l1.2-.4,1,1.1a37.3,37.3,0,0,0,4.8,5.8,7.6,7.6,0,0,1,2.5,4.4v.3h-.3a2.9,2.9,0,0,1-1.2.2Zm.4-4a36.4,36.4,0,0,1-4.8-5.9l-.6-.7h-.2a37.1,37.1,0,0,1,0,6.7l1,.6.3-.8.4.5a10.9,10.9,0,0,0,3.8,2.7,4.7,4.7,0,0,0,2.4.3A9.9,9.9,0,0,0,118.2,222.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M116.2,216.3s.3,3.9,2.2,6.2c0,0-.8,1.7-3.1,0s-2.5-7.3-2.5-7.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M115.1,222.8c-2.4-1.8-2.6-7.4-2.6-7.6v-.6l4.1,1.4v.2s.4,3.8,2.1,6l.2.2v.2a2.1,2.1,0,0,1-1.2.9h-.5A2.7,2.7,0,0,1,115.1,222.8Zm.8-6.2-2.6-.9c.1,1.4.6,5.2,2.3,6.5a2.2,2.2,0,0,0,1.9.6l.6-.3A12.7,12.7,0,0,1,115.9,216.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M117.5,194.1c3.8-2.1,5.5-3.4,4.7-6.1l-2.3-1.9-7.9-1-4.9,4.5-.7,3.2,4.6,2.9A15.1,15.1,0,0,0,117.5,194.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M111.2,196h-.1l-4.9-3.1.7-3.6,5.1-4.7,8.2,1.1,2.4,2.1h0c.9,3.1-1.3,4.6-4.9,6.5a13.9,13.9,0,0,1-6.4,1.6Zm6.2-2.2c3.9-2.1,5.2-3.3,4.5-5.5l-2.1-1.8-7.6-1-4.7,4.3-.6,2.8,4.3,2.7A14.3,14.3,0,0,0,117.4,193.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M118.6,186.8s3.7-.4,3.7,6.5-1.2,16.2-1.1,22a3.4,3.4,0,0,1-3.9-1.3,51.2,51.2,0,0,0-.4-9.4c-.7-5.3-.4-10.5,0-11.7a15.2,15.2,0,0,1-9.6-3.6c-4-3.7,6.1-6.4,6.1-6.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M116.9,214.2h-.1a50.1,50.1,0,0,0-.4-9.3,43.1,43.1,0,0,1-.1-11.4c-1.5-.1-6-.5-9.4-3.7a2.5,2.5,0,0,1-1-2.5c.7-2.7,7-4.5,7.2-4.5h.2l5.3,4a3,3,0,0,1,2,.8c1.2,1.1,1.9,3.2,1.9,6.1s-.3,7.6-.6,11.6a102.3,102.3,0,0,0-.5,10.4v.3h-.3a3.5,3.5,0,0,1-1.2.2A5.4,5.4,0,0,1,116.9,214.2Zm4.4-9.4c.3-4,.6-8,.6-11.5s-.9-4.8-1.6-5.5a2.7,2.7,0,0,0-1.6-.7h-.1l-5.2-3.9c-1.8.5-6.1,2.1-6.5,3.9a1.9,1.9,0,0,0,.8,1.8c3.8,3.6,9.3,3.5,9.3,3.5h.5l-.2.5a41,41,0,0,0,0,11.5,60.6,60.6,0,0,1,.4,9.3,2.8,2.8,0,0,0,3.1,1.1A97.7,97.7,0,0,1,121.3,204.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M113.1,188.2s4.7-.1,4.7,6.9-1.4,15.8-1.3,21.5c0,0-2.7,1.4-4.2-.8a51.2,51.2,0,0,0-.4-9.4,46.2,46.2,0,0,1-.1-11.2.5.5,0,0,0-.4-.5,15,15,0,0,1-9-3.6c-4-3.7,6.1-6.4,6.1-6.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M112,216h-.1a50.1,50.1,0,0,0-.4-9.3,47,47,0,0,1-.1-11.3h.4l-.5-.2a15.1,15.1,0,0,1-9.3-3.7,2.5,2.5,0,0,1-1-2.5c.7-2.7,7-4.5,7.2-4.5h.2l4.8,3.5a4.7,4.7,0,0,1,3,1.4c1.3,1.3,1.9,3.2,1.9,5.9a114.2,114.2,0,0,1-.7,11.4c-.3,3.7-.6,7.3-.6,10.1v.2h-.2a5.3,5.3,0,0,1-2,.5A3.3,3.3,0,0,1,112,216Zm4.7-9.6c.3-3.9.7-7.9.7-11.4s-.6-4.2-1.7-5.3a4.5,4.5,0,0,0-2.6-1.2H113l-4.7-3.5c-1.8.5-6.1,2.1-6.5,3.9a1.9,1.9,0,0,0,.8,1.8,14.5,14.5,0,0,0,8.8,3.5.7.7,0,0,1,.6.3.8.8,0,0,1,.2.7,45.2,45.2,0,0,0,.1,11.1,60.6,60.6,0,0,1,.4,9.3,2.9,2.9,0,0,0,3.4.7C116.1,213.6,116.4,210.1,116.7,206.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M106.7,174.9a39.9,39.9,0,0,1,10.3,7.4c4.4,4.6,5.3,5.8,5.3,5.8s-1.7-2.5-6.7-.6-5.5,4.1-5.6,6.2,1,1.7,1.2,1.9h0c-.9-.1-5.9-.9-12.4-5.5s-5.5-10.1-3.4-13.6S106.7,174.9,106.7,174.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M111,196c-.9-.1-6-1-12.6-5.6s-5.6-10.6-3.5-14.2,11.5-1.8,11.9-1.8h.1a39.5,39.5,0,0,1,10.4,7.5l5.2,5.6.2.2-.6.4-.2-.2c-.5-.5-2.2-1.8-6.2-.3s-5.2,4.1-5.4,5.9a1.6,1.6,0,0,0,.9,1.4l.2.2a.4.4,0,0,1,.1.5l-.2.3Zm9.4-9.5-3.7-3.9a42.4,42.4,0,0,0-10.1-7.3c-2.7-.4-9.7-1-11,1.4S92,185,98.9,189.8a33.5,33.5,0,0,0,11.1,5.3,2,2,0,0,1-.5-1.4c.1-2.3.7-4.6,5.9-6.6a11.8,11.8,0,0,1,3.6-.7A3.2,3.2,0,0,1,120.4,186.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M103.4,151.4s4-1,4.4,1.7a75.7,75.7,0,0,0,1.9,8.9c.9,3.2-2.8,4.5-2.8,4.5a27,27,0,0,0,1.7,9.5s-6.1,7-14.4,3.5l.3-1.8s1.4-8.3.6-12-3.3-5.1-1.9-8.6,6.6-5,6.6-5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M94.1,179.8h-.3l.4-2.1c0-.1,1.4-8.3.6-11.8a19.5,19.5,0,0,0-1.2-3.2c-.9-1.7-1.6-3.2-.7-5.7s6.6-5.2,6.9-5.3l3.5-.6a5.1,5.1,0,0,1,3.9.4,2.1,2.1,0,0,1,1,1.6,71.6,71.6,0,0,0,1.9,8.8c.8,2.6-1.3,4.3-2.8,4.9a27.4,27.4,0,0,0,1.7,9.1v.2l-.2.2c-.1.1-4.1,4.6-10.1,4.6A12.4,12.4,0,0,1,94.1,179.8Zm12.5-13.4v-.3h.2c.1,0,3.4-1.2,2.5-4a60.9,60.9,0,0,1-1.9-8.9,1.6,1.6,0,0,0-.7-1.1,4.3,4.3,0,0,0-3.3-.2l-3.5.6c-.1,0-5.1,1.5-6.3,4.8s-.2,3.4.6,5.1a12.6,12.6,0,0,1,1.3,3.3c.8,3.7-.6,11.8-.6,12.1l-.3,1.5c7.1,2.8,12.5-2.3,13.5-3.3A29,29,0,0,1,106.6,166.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M104.7,151.8s1-.8,1,.6.1,3.2.1,6.1-3.5,4.4-6.1-.5-4.4-3.4-4.4-3.4l1.6-3,4.2-2.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M99.3,158.2c-1.3-2.5-2.4-3.2-3.1-3.4a1.1,1.1,0,0,0-.8.1L94,156.1l2.5-4.8,4.6-2.5,3.6,2.6a1.1,1.1,0,0,1,.8-.1c.5.2.5.9.5,1.1v2c0,1.1.1,2.4.1,4.1a2.9,2.9,0,0,1-2.1,2.9h-.7C101.9,161.5,100.4,160.3,99.3,158.2Zm5.6-6.1-.2.2-3.7-2.6-3.9,2.1L96,154h.4c1.2.2,2.4,1.5,3.6,3.8s2.5,3.2,3.8,2.8a2.1,2.1,0,0,0,1.5-2.1c0-1.7,0-3-.1-4.1v-2c0-.3-.1-.4,0-.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M100.8,168.9a7.8,7.8,0,0,0,3.8-1.2l-.5-.6a5.2,5.2,0,0,1-6.3,0l-.5.6A6.1,6.1,0,0,0,100.8,168.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M108.6,190.1l.2-.7c-.1,0-7.3-2.3-9-6.3l-.7.3C100.9,187.7,108.2,190,108.6,190.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M98.6,181.9l.7-.2a2,2,0,0,1,.3-2l-.5-.6A3,3,0,0,0,98.6,181.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M102.9,159.1l.6-.2c1.6-1,1-5.1.9-5.6h-.8c.3,1.6.4,4.3-.5,4.8s-.2.1-.4,0-3-3.6-3.4-4.9l-.7.2c.4,1.1,2.2,4.7,3.9,5.3C102.6,159.1,102.7,159.1,102.9,159.1Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M105.5,144.1s2.2,7.5-1.3,9.8H104c-.6,0-3.1,0-5.2-3.1l-.2-.2c-.5-.1-2-.7-2.1-2.1a1.1,1.1,0,0,1,1-1.4c.3,0,.4-.3.3-.6L96.6,144c-.1-.2,0-.3.1-.5l2.5-2.7c.1-.1.3-.2.4-.1l5,1.1a.3.3,0,0,1,.3.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M98.3,151.1c-.5-.1-2.3-.7-2.4-2.4a1.5,1.5,0,0,1,1.3-1.8h0L96,144.2a1,1,0,0,1,.1-.9l2.5-2.7a.8.8,0,0,1,.8-.2l5,1.1a1,1,0,0,1,.6.5l.7,2c.1.3,2.3,7.8-1.5,10.2h-.7C102.7,154.4,100.4,154,98.3,151.1Zm6.1-9L99.3,141l-2.5,2.8,1.2,2.6a.9.9,0,0,1,0,.7.7.7,0,0,1-.6.4c-.5.1-.7.4-.7,1s1.4,1.6,1.8,1.8.3.2.4.3c2.1,3,4.4,2.9,4.9,2.9,3.2-2.1,1.2-9.1,1.2-9.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M99.8,138.2a7.1,7.1,0,0,1,7.5,7.9,12.9,12.9,0,0,1-.6,2.5c-.9,1.9-.6-2.4-4.7-3.6l-.3.7c0,.1-.1.1-.2.1l-1.9-1.2h-.1c-.3.2-2.3.9-1.1,2.8,0,.1,0,.2-.1.2s-1.9.1-1.5,1.1a8.1,8.1,0,0,0,1.3,2l1.2,1.2c.1.2.7,1.9-2.4,3.1a9.4,9.4,0,0,0-4.2,2.7c-.1.1-.2,0-.2-.1s.6-3.8,1.7-5.1.8-3.9-.4-5.5-1.3-5.4,3.1-7.9A7.9,7.9,0,0,1,99.8,138.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M92.5,158.1a.5.5,0,0,1-.3-.5c.2-1.1.7-3.9,1.8-5.3s.6-3.7-.4-5.1a5,5,0,0,1-.6-3.8c.3-1.3,1.2-3.1,3.9-4.6a7.5,7.5,0,0,1,2.9-.9,7.2,7.2,0,0,1,5.8,2.3,7.6,7.6,0,0,1,2.1,6.1,13.8,13.8,0,0,1-.6,2.6c-.2.3-.4.7-.7.7s-.6-.4-.9-.9a5.7,5.7,0,0,0-3.2-3.1l-.2.4-.3.3h-.4l-1.7-1.1h-.1c-.3.2-.9.5-1.1,1a1.3,1.3,0,0,0,.3,1.1.4.4,0,0,1,0,.5c-.1.1-.2.3-.4.3h-.3c-.2,0-.9.1-1,.3v.2a5.7,5.7,0,0,0,1.2,1.8l1.3,1.3h.1a1.8,1.8,0,0,1-.1,1.6,4.8,4.8,0,0,1-2.6,2.1,11.4,11.4,0,0,0-4.1,2.6l-.4.2C92.7,158.1,92.6,158.1,92.5,158.1Zm5.4-7.2a7.9,7.9,0,0,1-1.4-2.1.9.9,0,0,1,0-.9,1.9,1.9,0,0,1,1.4-.7,2.4,2.4,0,0,1-.2-1.4,2.6,2.6,0,0,1,1.4-1.5h.8l1.6,1.1.3-.8h.3a6.2,6.2,0,0,1,4,3.5l.2.3h0a10.5,10.5,0,0,0,.6-2.4,7,7,0,0,0-1.9-5.5,6.4,6.4,0,0,0-7.8-1.2,6.6,6.6,0,0,0-3.5,4.1,3.9,3.9,0,0,0,.5,3.2c1.1,1.6,1.9,4.1.3,6a10.2,10.2,0,0,0-1.5,4.1,12.2,12.2,0,0,1,3.8-2.2,3.9,3.9,0,0,0,2.2-1.6,1.6,1.6,0,0,0,.1-.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M102.7,147.5c.2.6.1,1.2-.3,1.3s-.8-.3-1-.9-.1-1.2.3-1.3A1.2,1.2,0,0,1,102.7,147.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M99.1,149.6h.2v-.8a.6.6,0,0,1-.5-.3l-.6.5A1.1,1.1,0,0,0,99.1,149.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M106.8,147.3h.8c0-.1-.8-7.4-7.2-7v.8C106.1,140.7,106.7,147.1,106.8,147.3Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M94.5,148.8h.8c-.8-4.4,1.3-5.9,1.3-6l-.4-.6C96,142.1,93.6,143.9,94.5,148.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M93,157.7a6,6,0,0,1,3.1-3.6,2.3,2.3,0,0,0,1.4-2.3h-.8a1.6,1.6,0,0,1-1,1.5,6.8,6.8,0,0,0-3.5,4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M94.7,157c-1.3-.7-2.7,2.1-3.4,7.6s0,6.1-.1,11.7c0,3.2.1,8.2,0,9.6a6.3,6.3,0,0,1-1,2.7L88.1,191c-.6.8-.5,1.7.4,2a2.4,2.4,0,0,0,2.8-.8l2-2.2.4.3a2.3,2.3,0,0,1-.4,1.4l-.5.8a2.8,2.8,0,0,0,2.2-1.7,2.2,2.2,0,0,0,0-1.6l-.3-.9a8.9,8.9,0,0,1-.6-4c.2-2.4.5-6.5.8-10.3C95.3,168.4,97.5,158.6,94.7,157Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M88.2,193.5a1.3,1.3,0,0,1-.9-.9,1.9,1.9,0,0,1,.4-1.7l2.1-2.4a4.3,4.3,0,0,0,.9-2.5c.1-.7,0-2.6,0-4.6v-4.9c0-2.2,0-3.6-.1-4.8a34.8,34.8,0,0,1,.2-7c.5-4.3,1.6-7.3,2.9-7.9a1.1,1.1,0,0,1,1.1,0c2.4,1.4,1.6,7.4.8,13.2-.2,1.6-.4,3.1-.5,4.4-.3,3.6-.6,7.6-.8,10.3a8.2,8.2,0,0,0,.6,3.8l.3.9a3.1,3.1,0,0,1,0,1.9,3.2,3.2,0,0,1-2.5,2H92l.4-.6.5-.8a1.7,1.7,0,0,0,.3-1l-1.7,1.9a2.8,2.8,0,0,1-2.2,1A3,3,0,0,0,88.2,193.5Zm5.8-3.2v.2a2.6,2.6,0,0,1-.4,1.5,4,4,0,0,0,1-1.2,1.5,1.5,0,0,0,0-1.3l-.3-.9a9.5,9.5,0,0,1-.6-4.1c.2-2.7.5-6.7.8-10.3.1-1.3.3-2.8.5-4.4.7-5,1.5-11.3-.4-12.4h-.4c-.8.4-1.9,2.8-2.4,7.3a32.9,32.9,0,0,0-.2,6.8c.1,1.3.1,2.7.1,4.9V186a6.5,6.5,0,0,1-1.1,2.9l-2.1,2.4a1.1,1.1,0,0,0-.3,1,.7.7,0,0,0,.5.4,2.1,2.1,0,0,0,2.4-.7l2.3-2.5Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M113.5,223.8h.8a3.6,3.6,0,0,1,.3-1.9l-.6-.5C113.9,221.5,113.5,222,113.5,223.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M119.1,226.2a3.1,3.1,0,0,0,1.2-.3l-.4-.6a1.8,1.8,0,0,1-1.6,0l-.3.7Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M123.3,224.3a3.1,3.1,0,0,0,1.2-.3l-.4-.6a1.8,1.8,0,0,1-1.6,0l-.3.7Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M106.4,165.9l-1.3.5.3.8,1.3-.6Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-2"
      d="M99.6,166.9l.2-.7a3,3,0,0,1-2.1-1.9l-.7.2A3.8,3.8,0,0,0,99.6,166.9Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M98.4,179.5l.7-.2h0a20.5,20.5,0,0,1,0-4.2h-.8A28.3,28.3,0,0,0,98.4,179.5Z"
      transform="translate(-1 -0.4)"
    />
    <path class="cls-2" d="M98.7,172.7l-.2,1.6h.8l.2-1.6Z" transform="translate(-1 -0.4)" />
    <path
      class="cls-3"
      d="M92.7,169.7a14.7,14.7,0,0,1,.4-3.5l-.7-.3a13,13,0,0,0-.5,3.8Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M120.7,183l-13.1,7.6a1.3,1.3,0,0,1-1.2,0L99,186.4c-.3-.2-.6-2.2,0-2.5l13.7-6.4,8.8,3.5C121.8,181.2,121,182.8,120.7,183Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M106.9,191.1l-.8-.2-7.4-4.2c-.5-.3-.6-1.5-.5-2s.3-1.1.6-1.2l13.9-6.4,8.9,3.5c.2.1.3.2.3.6a3.1,3.1,0,0,1-1.1,2.1l-13.1,7.6Zm5.8-13.2-13.6,6.3a.6.6,0,0,0-.1.4,2.4,2.4,0,0,0,.2,1.4l7.3,4.2a.8.8,0,0,0,.8,0l13.1-7.6a3.7,3.7,0,0,0,.7-1.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M120.7,181.4,107.6,189a1.3,1.3,0,0,1-1.2,0L99,184.8a.6.6,0,0,1,0-.9l13.7-7.9,8,4.6C121,180.7,121,181.2,120.7,181.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M106.9,189.5l-.8-.2-7.4-4.2a.9.9,0,0,1-.4-.8,1.2,1.2,0,0,1,.4-.8l13.9-8,8.2,4.7a.9.9,0,0,1,.4.8,1.2,1.2,0,0,1-.4.8l-13.1,7.6Zm5.8-13.1-13.5,7.8a.1.1,0,0,0-.1.1h.1l7.4,4.2a.8.8,0,0,0,.8,0l13.1-7.6h0Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-2"
      d="M121.5,181,107,189.4V177.8a.7.7,0,0,1,.3-.6l13.9-8c.1-.1.3,0,.3.2Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M106.6,190V177.7a1.1,1.1,0,0,1,.5-.9l13.9-8a.6.6,0,0,1,.6,0,.5.5,0,0,1,.3.5v11.9Zm14.5-20.4-13.6,7.9c-.1.1-.1.1-.1.3v11l13.8-7.9V169.6Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-4"
      d="M114.9,180.4l-1.4.8c-.2.1-.4,0-.4-.3v-1.4a.8.8,0,0,1,.4-.7l1.4-.8c.2-.1.4,0,.4.3v1.5A.8.8,0,0,1,114.9,180.4Z"
      transform="translate(-1 -0.4)"
    />
    <path
      class="cls-3"
      d="M113.4,181.6h-.3a.6.6,0,0,1-.3-.6v-1.4a1.1,1.1,0,0,1,.6-1l1.4-.8h.6a.6.6,0,0,1,.3.6v1.5a1,1,0,0,1-.6,1l-1.4.8Zm1.5-3.2-1.2.7c-.1,0-.2.2-.2.4v1.3l1.2-.7c.1,0,.2-.2.2-.4Z"
      transform="translate(-1 -0.4)"
    />
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    seedAnim() {
      const path = this.$refs["arrowline"],
        pathlength = path.getTotalLength();

      gsap.set(path, {
        strokeDashoffset: pathlength,
        strokeDasharray: pathlength,
      });

      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-seed",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            ease: "sine",
          },
        })
        .add("seedfunding")
        .fromTo(
          ".barchartseed",
          {
            scaleY: 0,
            transformOrigin: "50% 100%",
          },
          {
            scaleY: 1,
            stagger: -0.15,
          },
          "seedfunding"
        )
        .to(
          path,
          1.5,
          {
            strokeDashoffset: 0,
          },
          "seedfunding"
        )
        .from(
          "#arrowhead",
          {
            opacity: 0,
            ease: "sine",
          },
          "seedfunding+=1"
        );

      return tl;
    },
  },
  mounted() {
    this.seedAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-5 {
  fill: none;
}

.cls-2 {
  fill: #ffad43;
}

.cls-3 {
  fill: #0e1e25;
}

.cls-4 {
  fill: #fff;
}

.cls-5 {
  stroke: #0e1e25;
  stroke-miterlimit: 10;
  stroke-width: 3px;
}
</style>
